import { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import CustomSearchDropdown from "../../Component/CustomDropdown/CustomSearchDropdown.js"
import { useNavigate, useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';

import { Row, Col, Container, Form, Table, Card, Accordion } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import CustomMultiSelectDropdown from "../../Component/Dropdown/index.js"
import plusIcon from '../../assets/images/plus-btn-green-icon.svg';
import minusIcon from '../../assets/images/minus-btn-green-icon.svg';
import exclamationIcon from '../../assets/images/exclamation-icon.svg';
import exclamationTraingleIcon from '../../assets/images/exclamation-traingle-icon.svg';
import cancelIconMdl from '../../assets/images/cancel-icon.svg';
import deleteIconMdl from '../../assets/images/delete-icon-web.svg';
import dataNameIcon from '../../assets/images/data-name-icon.svg';
import calendarIcon from '../../assets/images/calendar-iinput-icon.svg';
import locationIcon from '../../assets/images/location-icon-web.svg';
import userIcon from '../../assets/images/user-icon-web.svg';
import globalIcon from '../../assets/images/global-icon-web.svg';
import fieldIcon from '../../assets/images/field-icon-web.svg';
import updateIcon from '../../assets/images/update-icon.svg';
import arrowRightIcon from '../../assets/images/arrow-right-icon.svg';
import summaryIcon from '../../assets/images/view-summary-icon.svg';
import requestIcon from '../../assets/images/request.svg'

import {
    getDeals, getEquipmentNumbers, getBasins, getBasinsOptions, getEqipment, saveEqipment, getHose, saveHose, getHoseType, saveJob,
    getCustomPackage, saveCustomPackageItems, getHSE, saveHSE, getLabItems, saveLabItems, getItems, saveItems, get3rdParty, save3rdParty,
    getSuppliedChainOptions, getFittinngType, deleteEquipment, getAllStatus, postReSupplyRequest, getHistoricalData,
    getPrimaryBasinOptions
} from "../../Services/dashboard";

import { getPriorityList } from "../../Services/resupply.js"
import FullScreenLoader from "../../Component/Loader";
import Header from "../../Component/Header";
import { useSelector } from "react-redux";

function Home() {
    const location = useLocation();
    const { deal_id, countryId } = useParams();
    const navigate = useNavigate();
    let [activeTab, setActiveTab] = useState('equipment')
    let [isBasinLoading, setIsBasinLoading] = useState(false)
    const [showLoader, setShowLoader] = useState(false);
    const [housesOptions, setHousesOptions] = useState([]);
    let [raNumbers, setRaNumbers] = useState([])
    let [basins, setBasins] = useState([])
    let [basinsOptions, setBasinsOptions] = useState([])
    let [suppliedChainOptions, setSuppliedChainOptions] = useState([])
    let [assetReset, setAssetReset] = useState(false)
    let [assetDelete, setAssetDelete] = useState(false)
    let [itemsData, setItemsData] = useState([])
    let [equipmentIndexID, setEquipmentIndexID] = useState(null)
    const [pendingSelection, setPendingSelection] = useState(null)
    const [fittingOptions, setFittingOptions] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [priorityOptions, setPriorityOptions] = useState([]);
    const [primaryBasinOptions, setPrimaryBasinOptions] = useState([]);
    const [isRequesting, setIsRequesting] = useState(false);
    const [requestType, setRequestType] = useState('Loadout');
    const [jobDetailsId, setJobDetailsId] = useState('');
    const [historicalRequests, setHistoricalRequests] = useState([]);
    const [isHistoryLoading, setIsHistoryLoading] = useState(false);
    const [reSupplyErrors, setResupplyErrors] = useState({
        Needed_On: '',
        Status: '',
        priority: ''
    });
    const [reRequestDetails, setReRequestDetails] = useState({
        "requested": false,
        "Needed_On": "",
        "Status": null,
        "priority": "",
        "comments": null
    });
    let [deals, setDeals] = useState(
        {
            "ID": '',
            "HS_Deal_ID": '',
            "JobName": "",
            "CustomerName": "",
            "PlatformName": null,
            "NeededOnSiteBy": "",
            "SiteAddress": "",
            "AreaManager": "",
            "FieldLeader": "",
            "PrimaryBasin": "",
            "isDeployed": false
        }
    )
    let [equipments, setEquipments] = useState(
        [
            {
                isDeployed: false,
                equipment_id: 0,
                AssetSubType: [],
                isSpare: true,
                SpareCount: 0,
                NonBillableCount: 0,
                assetType: '',
                supplyChainAssetType: '',
                SalesQuantity: null,
                OperationQuantity: null,
                SuppliedQuantity: null,
                Supply_Chain_Asset_Type: "",
                Assets: [
                    {
                        SuppliedBy: {
                            value: "", label: ""
                        },
                        AssetDetails: [
                            {
                                value: null, label: "", AssetID: null
                            }
                        ],
                        AssetCount: 0
                    },

                ],
                notes: ''
            }
        ]
    )

    let [houses, setHouses] = useState([
        {
            index: 0,
            houseType: '',
            houseDiameter: null,
            sectionLength: null,
            endFittingType1: '',
            endFittingType2: "",
            quantity: null,
            suppliedBy: '',
            ID: null,
            isDeployed: false
        },
    ]);

    let [items, setItems] = useState([
        {
            index: 0,
            itemName: '',
            quantity: null,
            suppliedBy: '',
            isDeployed: false

        }
    ])

    let [customPackages, setCustomPackages] = useState([
        {
            index: 0,
            itemName: '',
            quantity: null,
            suppliedBy: '',
            notes: '',
            ID: null,
            isDeployed: false
        }
    ])
    const [hseItems, setHseItems] = useState([
        {

            index: 0,
            ID: 0,
            HSEItemID: 0,
            itemName: "",
            quantity: null,
            // size: "",
            Notes: "",
            suppliedBy: "",
            isDeployed: false
        },
    ]);

    const [labItems, setLabItems] = useState([
        {
            index: 0,
            ID: 0,
            LabItemsID: 0,
            itemName: "",
            quantity: null,
            suppliedBy: "",
            isDeployed: false
        }
    ]);

    const [thirdParty, setThirdParty] = useState([
        {
            index: 0,
            "ID": null,
            "BCR_ID": null,
            "AssetName": "",
            "Quantity": null,
            "SuppliedBy": ""
        },
    ]);

    const [countryOption, setCountryOption] = useState([
        { label: 'USA', value: 'USA' },
        { label: 'Canada', value: 'Canada' }
    ]);
    const [selectedCountry, setSelectedCountry] = useState({});

    // --- REFS TO PREVENT DOUBLE FETCHES ---
    const dealFetchedRef = useRef(null);
    const subDataFetchedRef = useRef(null);
    const historyFetchedRef = useRef(null);

    // Helper functions to check if a row is empty
    const isEquipmentRowEmpty = (equipment) => {
        // Ignore sales fields (AssetType, SalesQuantity) because they are read-only and pre-filled.
        if (equipment.supplyChainAssetType && equipment.supplyChainAssetType.trim() !== '') return false;
        if (equipment.OperationQuantity && Number(equipment.OperationQuantity) > 0) return false;
        if (equipment.SpareCount && Number(equipment.SpareCount) > 0) return false;
        if (equipment.NonBillableCount && Number(equipment.NonBillableCount) > 0) return false;
        if (equipment.SuppliedQuantity && Number(equipment.SuppliedQuantity) > 0) return false;
        if (equipment.notes && equipment.notes.trim() !== '') return false;

        // Check Assets
        if (equipment.Assets?.some(asset =>
            (asset.SuppliedBy?.value && asset.SuppliedBy.value.trim() !== '') ||
            asset.AssetDetails?.some(detail => detail.value)
        )) return false;

        return true;
    };

    const isHoseRowEmpty = (hose) => {
        if (hose.houseType && hose.houseType.trim() !== '') return false;
        if (hose.houseDiameter && Number(hose.houseDiameter) > 0) return false;
        if (hose.sectionLength && Number(hose.sectionLength) > 0) return false;
        if (hose.endFittingType1 && hose.endFittingType1.trim() !== '') return false;
        if (hose.endFittingType2 && hose.endFittingType2.trim() !== '') return false;
        if (hose.quantity && Number(hose.quantity) > 0) return false;
        if (hose.suppliedBy?.value && hose.suppliedBy.value.trim() !== '') return false;
        return true;
    };

    const isCustomRowEmpty = (custom) => {
        if (custom.itemName && custom.itemName.trim() !== '') return false;
        if (custom.quantity && Number(custom.quantity) > 0) return false;
        if (custom.suppliedBy && custom.suppliedBy.trim() !== '') return false;
        if (custom.notes && custom.notes.trim() !== '') return false;
        return true;
    };

    // ==================== EFFECTS ====================

    // 1) Set selectedCountry from URL param (only once)
    useEffect(() => {
        if (countryId && countryId !== 'undefined') {
            setSelectedCountry(
                countryId === 'USA'
                    ? { label: 'USA', value: 'USA' }
                    : { label: 'Canada', value: 'Canada' }
            );
        }
    }, [countryId]);

    // 2) Fetch deal by ID (only when deal_id changes)
    useEffect(() => {
        const storedDealId = localStorage.getItem('dealId');
        const currentDealId = deal_id;

        if (currentDealId && currentDealId !== 'undefined') {
            if (storedDealId !== currentDealId) {
                if (!currentDealId || currentDealId === 'undefined') return;
                localStorage.setItem('dealId', currentDealId);
            }
            // Only fetch if not already fetched for this ID
            if (dealFetchedRef.current !== currentDealId) {
                dealFetchedRef.current = currentDealId;
                fetchDealById(currentDealId);
            }
        } else {
            // No deal_id in URL, use stored
            if (storedDealId && storedDealId !== 'undefined') {
                navigate(`/home/${storedDealId}/${localStorage.countryId}`);
                if (dealFetchedRef.current !== storedDealId) {
                    dealFetchedRef.current = storedDealId;
                    fetchDealById(storedDealId);
                }
            }
        }
    }, [deal_id]); // removed selectedCountry to avoid re-fetch

    // 3) Fetch static options (hose types, basins, supplied chain, fitting) – runs when countryId changes
    useEffect(() => {
        if (countryId && countryId !== 'undefined') {
            fetchHoseTypeOptions();
            fetchBasinsOptions();
            fetchSuppliedOptions();
            fetchFittingOptions();
            fetchAllStatus();
            fetchPriorityOption();
        }
    }, [countryId]);

    // 4) Fetch sub-data (equipment, hose, etc.) when deals.ID, countryId, or requestType changes
    useEffect(() => {
        if (deals.ID) {
            const key = `${deals.ID}-${countryId}-${requestType}`;
            if (subDataFetchedRef.current !== key) {
                subDataFetchedRef.current = key;
                fetchEqipment(deals.ID);
                fetchHose(deals.ID);
                fetchCustomPackage(deals.ID);
                fetchHSEItems(deals.ID);
                fetchLabItems(deals.ID);
                fetchItems(deals.ID);
                fetch3rdParty(deals.ID);
                fetchPrimaryBasinOption()
            }
        }
    }, [deals.ID, countryId, requestType]);

    // 5) Fetch historical requests when jobDetailsId is available
    useEffect(() => {
        if (jobDetailsId && jobDetailsId !== 'undefined') {
            const key = jobDetailsId;
            if (historyFetchedRef.current !== key) {
                historyFetchedRef.current = key;
                fetchHistoricalRequests();
            }
        }
    }, [jobDetailsId]);

    // 6) Parse URL query params for requestType and jobDetailsId
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const reqType = queryParams.get("requestType");
        const jdId = queryParams.get("jobDetailsId");
        if (reqType) {
            setRequestType(reqType);
            setJobDetailsId(jdId);
        } else {
            setRequestType('Loadout');
        }
    }, [location.search]);

    // 7) Add blank asset rows (kept as is)
    useEffect(() => {
        if (!equipments?.length) return;
        const updatedEquipments = equipments.map((equipment) => {
            const assets = equipment.Assets || [];
            const lastAsset = assets[assets.length - 1];
            const alreadyHasBlankRow = assets.some(
                (a) => !a?.SuppliedBy?.value && (!a.AssetDetails || !a.AssetDetails.filter(a => a.value !== null).length)
            );
            let updatedAssets = [...assets];
            const lastRowHasValidSupplier = lastAsset?.SuppliedBy?.value;
            if ((assets.length === 0 || lastRowHasValidSupplier) && !alreadyHasBlankRow) {
                updatedAssets.push({
                    SuppliedBy: null,
                    AssetDetails: [],
                });
            }
            return {
                ...equipment,
                Assets: updatedAssets,
            };
        });
        const isChanged = JSON.stringify(equipments) !== JSON.stringify(updatedEquipments);
        if (isChanged) {
            setEquipments(updatedEquipments);
        }
    }, [equipments, raNumbers]);

    // -------- API CALL FUNCTIONS (unchanged) --------
    const fetchHistoricalRequests = async () => {
        if (!jobDetailsId) return;
        setIsHistoryLoading(true);
        try {
            const res = await getHistoricalData(localStorage.access_token, jobDetailsId);
            if (res?.status === 200 && res?.data?.status === 200) {
                setHistoricalRequests(res.data?.data || []);
            }
        } catch (error) {
            console.error("Failed to fetch historical requests:", error);
        } finally {
            setIsHistoryLoading(false);
        }
    };

    let fetchDealById = async (deal_id) => {
        if (!countryId || countryId === 'undefined' || !deal_id || deal_id === 'undefined') return
        setShowLoader(true)
        let res = await getDeals(localStorage?.access_token, deal_id, countryId)
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                setDeals(res?.data?.result)
                if (res?.data?.result?.ID) {
                    fetchEqipment(res?.data?.result?.ID)
                } else {
                    setShowLoader(false)
                    setEquipments(
                        [
                            {
                                isDeployed: false,
                                equipment_id: 0,
                                AssetSubType: [],
                                isSpare: true,
                                SpareCount: 0,
                                NonBillableCount: 0,
                                assetType: '',
                                supplyChainAssetType: '',
                                SalesQuantity: null,
                                OperationQuantity: null,
                                SuppliedQuantity: null,
                                Supply_Chain_Asset_Type: "",
                                Assets: [
                                    {
                                        SuppliedBy: {
                                            value: "", label: ""
                                        },
                                        AssetDetails: [
                                            {
                                                value: null, label: "", AssetID: null
                                            }
                                        ],
                                        AssetCount: 0
                                    },

                                ],
                                notes: ''
                            }
                        ]
                    )
                    setHouses([{
                        index: 0,
                        houseType: '',
                        houseDiameter: null,
                        sectionLength: null,
                        endFittingType1: '',
                        endFittingType2: "",
                        quantity: null,
                        suppliedBy: '',
                        ID: null,
                        isDeployed: false
                    }
                    ])
                    setItemsData([])
                    setLabItems([
                        {
                            index: 0,
                            ID: 0,
                            LabItemsID: 0,
                            itemName: "",
                            quantity: null,
                            suppliedBy: "",
                            isDeployed: false
                        }
                    ])
                    setHseItems([
                        {
                            index: 0,
                            ID: 0,
                            LabItemsID: 0,
                            itemName: "",
                            quantity: null,
                            suppliedBy: "",
                            isDeployed: false
                        }
                    ])
                    setCustomPackages([
                        {
                            index: 0,
                            itemName: '',
                            quantity: null,
                            suppliedBy: '',
                            notes: '',
                            ID: null,
                            isDeployed: false
                        }
                    ])
                }

            }
        }
        ///  setShowLoader(false)
    }

    let fetchAllStatus = async () => {
        let res = await getAllStatus(localStorage.access_token)
        if (res && res?.data && res?.data?.status == 200) {
            const options = res?.data?.data.map(item => ({
                value: item.ID,
                label: item.Status
            }));
            setStatusList(options)

        }
    }

    let fetchPriorityOption = async () => {
        let res = await getPriorityList(localStorage.access_token)
        if (res && res?.data && res?.data?.status == 200) {
            const options = res?.data?.data.map(item => ({
                value: item.ID,
                label: item.Priority
            }));
            setPriorityOptions(options)
        }
    }

    let fetchPrimaryBasinOption = async () => {
        let res = await getPrimaryBasinOptions(localStorage.access_token)
        if (res && res?.data && res?.data?.status == 200) {
            const options = res?.data?.data.map(item => ({
                value: item,
                label: item
            }));
            setPrimaryBasinOptions(options)
        }
    }

    let fetch3rdParty = async (deal_id) => {
        let res = await get3rdParty(localStorage?.access_token, deal_id, countryId)
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                if (!res?.data?.result?.result) return
                setThirdParty(res?.data?.result?.result)
            }
        }
    }
    let fetchEqipment = async (equipment_id) => {
        setShowLoader(true)
        let res = await getEqipment(
            localStorage?.access_token,
            equipment_id,
            countryId,
            requestType
        )
        setShowLoader(false)

        if (res.status === 200 && res.data?.status_code === 200) {
            const result = res?.data?.result?.result || []

            if (!result.length) return

            const output = result
                // ✅ REMOVE deleted equipments
                .filter(item => item?.is_delete !== true)
                // ✅ THEN map
                .map(item => ({
                    isDeployed: item?.isDeployed,
                    equipment_id: item.EquipmentID ?? 0,
                    AssetType: item.AssetType ?? '',
                    AssetSubType: item.AssetSubType ?? [],
                    isSpare: item.isSpare ?? true,
                    SpareCount: item.SpareCount ?? 0,
                    NonBillableCount: item.NonBillableCount ?? 0,
                    supplyChainAssetType: item.SupplyChainAssetType ?? '',
                    SalesQuantity: item.SalesQuantity ?? null,
                    OperationQuantity: item.OperationQuantity ?? null,
                    SuppliedQuantity: item.SuppliedQuantity ?? null,
                    Assets: item?.Assets?.length
                        ? item.Assets.map(asset => ({
                            SuppliedBy: asset.SuppliedBy
                                ? { value: asset.SuppliedBy, label: asset.SuppliedBy }
                                : null,
                            AssetCount: asset?.AssetCount ?? 0,
                            AssetDetails: asset?.AssetDetails?.map(detail => ({
                                AssetID: detail.AssetID ?? null,
                                label: detail.AssetNo ?? '',
                                value: detail.BCR_ID ?? null
                            })) || []
                        }))
                        : [],
                    Notes: item.Notes ?? ''
                }))

            setEquipments(output)
        }
    }

    let fetchHose = async (hose_id) => {
        try {
            let res = await getHose(localStorage?.access_token, hose_id, countryId, requestType);
            if (!res.data.result?.length) return
            if (res.status === 200 && res.data?.status_code === 200) {
                const formatted = res.data.result.map((item, index) => ({
                    index,
                    ID: item.ID,
                    isDeployed: item?.isDeployed,
                    houseType: item.HoseType ?? '',
                    houseDiameter: item.HoseDiameter ?? null,
                    sectionLength: item.SectionLength ?? null,
                    endFittingType1: item.EndFittingType1 ?? '',
                    endFittingType2: item.EndFittingType2 ?? '',
                    quantity: item.Quantity ?? null,
                    suppliedBy: item.SuppliedBy
                        ? { value: item.SuppliedBy, label: item.SuppliedBy } // ✅ fix
                        : null,
                }));

                setHouses(formatted);
            }
        } catch (err) {
            console.error("Error fetching hoses:", err);
            setShowLoader(false);
        }
    };

    let fetchCustomPackage = async (package_id) => {
        try {
            const res = await getCustomPackage(localStorage?.access_token, package_id, countryId, requestType);
            if (res.status === 200 && res.data?.status_code === 200) {
                if (!res.data.result?.length) return
                const formatted = res.data.result.map((item, index) => ({
                    ID: item.ID,
                    index,
                    itemName: item.ItemName ?? '',
                    quantity: item.Quantity ?? null,
                    suppliedBy: item.SuppliedBy ?? '',
                    notes: item.Notes ?? '',
                    isDeployed: item?.isDeployed
                }));
                setCustomPackages(formatted);
            }
        } catch (error) {
            console.error("Error fetching custom packages:", error);
            setShowLoader(false);
        }
    };

    const fetchHSEItems = async (job_id) => {
        try {
            const res = await getHSE(localStorage?.access_token, job_id, countryId, requestType);
            if (!res.data.result) return
            if (res.status === 200 && res.data?.status_code === 200) {
                const formatted = res.data.result.map((item, index) => ({
                    ID: item.ID ?? 0,
                    HSEItemID: item.HSEItemID ?? 0,
                    itemName: item.ItemName ?? "",
                    quantity: item.Quantity ?? "",
                    // size: item.Size ?? "",
                    Notes: item.Notes ?? "",
                    isDeployed: item?.isDeployed,
                    suppliedBy: item.SuppliedBy ?? "",
                }));
                setHseItems(formatted);
            }
        } catch (error) {
            console.error("Error fetching HSE items:", error);
            setShowLoader(false);
        }
    };
    const fetchLabItems = async (job_id) => {
        try {
            const res = await getLabItems(localStorage?.access_token, job_id, countryId, requestType);
            if (!res.data.result) return
            if (res.status === 200 && res.data?.status_code === 200) {
                const formatted = res.data.result.map((item, index) => ({
                    index,
                    ID: item.ID ?? null,
                    isDeployed: item.isDeployed,
                    LabItemsID: item.LabItemsID ?? null,
                    itemName: item.ItemName ?? "",
                    quantity: item.Quantity ?? null,
                    suppliedBy: item.SuppliedBy ?? "",
                }));

                setLabItems(formatted);
            }
        } catch (error) {
            console.error("Error fetching lab items:", error);
            setShowLoader(false);
        }
    };

    let fetchRsNumber = async (RsNumber, basin, equipmentIndex, assetIndex) => {
        setIsBasinLoading(true);
        let res = await getEquipmentNumbers(localStorage?.access_token, RsNumber, basin, countryId);
        setIsBasinLoading(false);

        if (res.status === 200 && res.data?.status_code === 200) {
            const output = res?.data?.result?.data?.map(item => ({
                value: item.ID,
                label: item.AssetName
            }));

            const count = res?.data?.result?.count || 0;
            setRaNumbers(output);
            setEquipments(prevEquipments => {
                const updatedEquipments = [...prevEquipments];
                const targetEquipment = { ...updatedEquipments[equipmentIndex] };
                const updatedAssets = [...(targetEquipment.Assets || [])];
                const targetAsset = { ...updatedAssets[assetIndex] };
                targetAsset.AssetCount = count;
                updatedAssets[assetIndex] = targetAsset;
                targetEquipment.Assets = updatedAssets;
                updatedEquipments[equipmentIndex] = targetEquipment;

                return updatedEquipments;
            });
        }
    };

    let fetchBasins = async (assetType) => {
        setIsBasinLoading(true)
        let res = await getBasins(localStorage?.access_token, assetType, countryId)
        setIsBasinLoading(false)
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                const output = res?.data?.result.map(item => ({
                    value: item,
                    label: item
                }));
                setBasins(output)
            }
        }
    }

    let fetchSuppliedOptions = async () => {
        let res = await getSuppliedChainOptions(localStorage?.access_token, countryId)
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                setSuppliedChainOptions(res?.data?.result)
            }
        }
    }

    let fetchHoseTypeOptions = async () => {
        let res = await getHoseType(localStorage?.access_token, countryId)
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                const output = res?.data?.result.map(item => ({
                    value: item.ID,
                    label: item.HoseType
                }));
                setHousesOptions(output)
            }
        }
    }

    let fetchItems = async (id) => {
        let res = await getItems(localStorage?.access_token, id, countryId, requestType)
        if (!res) return
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                setItemsData(res?.data?.result)

            }
        }

    }
    let fetchBasinsOptions = async () => {
        let res = await getBasinsOptions(localStorage?.access_token, countryId)
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                const output = res?.data?.result.map(item => ({
                    value: item,
                    label: item
                }));
                setBasinsOptions(output)
            }
        }
    }

    let fetchFittingOptions = async () => {
        let res = await getFittinngType(localStorage?.access_token, countryId)
        if (res.status == 200) {
            if (res.data?.status_code == 200) {
                setFittingOptions(res.data?.result)
            }
        }
    }

    let handleAddData = (type, index) => {
        if (type === 'equipment') {
            let temp = [...equipments]
            let obj = {
                isDeployed: false,
                index: equipments.length,
                Supply_Chain_Asset_Type: "",
                AssetSubType: [],
                isSpare: true,
                SpareCount: 0,
                NonBillableCount: 0,
                equipment_id: null,
                assetType: '',
                SalesQuantity: '',
                OperationQuantity: null,
                SuppliedQuantity: null,
                Assets: [
                    {
                        SuppliedBy: {
                            value: "", label: ""
                        },
                        AssetDetails: [
                            {
                                value: null, label: "", AssetID: null
                            }
                        ],
                        AssetCount: 0
                    },

                ],
                notes: ''
            }
            temp.push(obj)
            setEquipments(temp)
        }
        else if (type === 'house') {
            let temp = [...houses]
            let obj = {
                index: houses.length,
                houseType: '',
                houseDiameter: null,
                sectionLength: null,
                endFittingType: '',
                quantity: null,
                suppliedBy: '',
                ID: null,
                isDeployed: false
            }
            temp.push(obj)
            setHouses(temp)
        }

        else if (type === 'item') {
            let temp = [...items]
            let obj = {
                index: items.length,
                itemName: '',
                quantity: null,
                suppliedBy: '',
            }
            temp.push(obj)
            setItems(temp)
        }
        else if (type === 'custom') {
            let temp = [...customPackages];
            let obj = {
                index: customPackages.length,
                packageID: 0,
                packageName: '',
                description: '',
                quantity: null,
                suppliedBy: null,
                isDeployed: false
            };
            temp.push(obj);
            setCustomPackages(temp);
        }
        else if (type === 'lab') {
            let temp = [...labItems];
            let obj = {
                index: labItems.length,
                ID: null,
                LabItemsID: 0,
                itemName: "",
                quantity: null,
                suppliedBy: "",
                isDeployed: false
            };
            temp.push(obj);
            setLabItems(temp);
        }

        else if (type === 'hse') {
            let temp = [...hseItems];
            let obj = {
                index: hseItems.length,
                ID: null,
                HSEItemID: 0,
                itemName: "",
                quantity: null,
                size: "",
                suppliedBy: "",
                isDeployed: false
            }
            temp.push(obj);
            setHseItems(temp);
        }

        else if (type === '3rdParty') {
            let temp = [...thirdParty];
            let obj = {
                index: thirdParty.length,
                "ID": null,
                "BCR_ID": null,
                "AssetName": "",
                "Quantity": null,
                "SuppliedBy": ""
            };
            temp.push(obj);
            setThirdParty(temp);
        }

    }

    let handleRemoveData = (type, val) => {
        if (type === 'equipment') {
            setEquipmentIndexID(val)
            setAssetDelete(true)
            // let temp = [...equipments]
            // let updatedData = temp.filter(item => {
            //     if (item.index !== undefined && item.index !== null) {
            //         return item.index !== val.index;
            //     } else {
            //         return item.equipment_id !== val.equipment_id
            //     }
            // });
            // setEquipments(updatedData)
        }
        else if (type === 'house') {
            let temp = [...houses]
            let updatedData = temp.filter(item => {
                if (item.index !== undefined && item.index !== null) {
                    return item.index !== val.index;
                } else {
                    return item.ID !== val.ID
                }
            });
            setHouses(updatedData)
        }
        else if (type === 'item') {
            let temp = [...items]
            let updatedData = temp.filter((val => val.index !== val))
            setItems(updatedData)
        }
        else if (type === 'custom') {
            let temp = [...customPackages]
            let updatedData = temp.filter(item => {
                if (item.index !== undefined && item.index !== null) {
                    return item.index !== val.index;
                } else {
                    return item.ID !== val.ID
                }
            });
            setCustomPackages(updatedData)
        }

        else if (type === 'lab') {
            let temp = [...labItems]
            let updatedData = temp.filter(item => {
                if (item.index !== undefined && item.index !== null) {
                    return item.index !== val.index;
                } else {
                    return item.ID !== val.ID
                }
            });
            setLabItems(updatedData)
        }
        else if (type === 'hse') {
            let temp = [...hseItems]
            let updatedData = temp.filter(item => {
                if (item.index !== undefined && item.index !== null) {
                    return item.index !== val.index;
                } else {
                    return item.HSEItemID !== val.HSEItemID
                }
            });
            setHseItems(updatedData)
        }
        else if (type === '3rdParty') {
            let temp = [...thirdParty]
            let updatedData = temp.filter(item => {
                if (item.index !== undefined && item.index !== null) {
                    return item.index !== val.index;
                } else {
                    return item.BCR_ID !== val.BCR_ID
                }
            });
            setThirdParty(updatedData)
        }
    }

    let handleInputChange = (type, event, index) => {
        let { name, value } = event.target

        if (type === 'equipment') {
            let temp = [...equipments]
            const prevValue = temp[index][name];
            temp[index][name] = value

            // If SuppliedQuantity is changed to 0 or empty, reset SuppliedBy and AssetDetails
            if (name === 'SuppliedQuantity' && (value === '' || Number(value) === 0)) {
                if (prevValue !== '' && Number(prevValue) !== 0) {
                    // Reset all Assets for this equipment
                    temp[index].Assets = temp[index].Assets.map(asset => ({
                        SuppliedBy: null,
                        AssetDetails: [],
                        AssetCount: 0
                    }));
                }
            }

            setEquipments(temp)
        }

        if (type === "opsEquipment") {
            let temp = [...equipments];

            const newValue = Number(value);
            const salesQty = Number(temp[index].SalesQuantity);

            temp[index][name] = newValue;

            // total extra allowed: (OperationQuantity - SalesQuantity)
            const totalAllowed = Math.max(0, newValue - salesQty);

            let currentSpare = Number(temp[index].SpareCount);
            let currentNonBillable = Number(temp[index].NonBillableCount);

            // If non-billable exceeds allowed, reduce it
            if (currentNonBillable > totalAllowed) {
                currentNonBillable = totalAllowed;
            }

            // Spare should be whatever remains after non-billable
            const updatedSpare = Math.max(0, totalAllowed - currentNonBillable);

            temp[index].SpareCount = updatedSpare;
            temp[index].NonBillableCount = currentNonBillable;

            setEquipments(temp);
        }

        if (type === "adEquipment") {
            let temp = [...equipments];
            const field = event.target.name;
            const enteredValue = Number(event.target.value);
            const salesQty = Number(temp[index].SalesQuantity);
            const opsQty = Number(temp[index].OperationQuantity);

            const totalAllowed = Math.max(0, opsQty - salesQty);
            if (field === "SpareCount") {
                const newSpare = Math.min(enteredValue, totalAllowed);
                const newNonBillable = Math.max(0, totalAllowed - newSpare);

                temp[index].SpareCount = newSpare;
                temp[index].NonBillableCount = newNonBillable;
            }

            if (field === "NonBillableCount") {
                const newNonBillable = Math.min(enteredValue, totalAllowed);
                const newSpare = Math.max(0, totalAllowed - newNonBillable);

                temp[index].NonBillableCount = newNonBillable;
                temp[index].SpareCount = newSpare;
            }

            setEquipments(temp);
        }

        else if (type === 'house') {
            let temp = [...houses]
            temp[index][name] = value
            setHouses(temp)
        }
        else if (type === 'item') {
            let temp = [...items]
            temp[index][name] = value
            setItems(temp)
        }
        else if (type === "custom") {
            const temp = [...customPackages];
            temp[index][name] = value;
            setCustomPackages(temp);
        }
        else if (type === "lap") {
            const temp = [...labItems];
            temp[index][name] = value;
            setLabItems(temp);
        }
        else if (type === "hse") {
            const temp = [...hseItems];
            temp[index][name] = value;
            setLabItems(temp);
        }
        else if (type === "3rdParty") {
            const temp = [...thirdParty];
            temp[index][name] = value;
            setThirdParty(temp);
        }
    }

    const handleCreateHouseOption = (inputValue, index) => {
        const newOption = {
            value: inputValue.trim(),
            label: inputValue.trim()
        };

        // Add to options list
        setHousesOptions(prev => [...prev, newOption]);

        // Update selected value
        handleSelectChange("house", newOption, index, "houseType");
    };

    let handleSelectChange = (type, selectedOption, index, fieldName) => {
        if (type === 'equipment') {
            let temp = [...equipments]
            temp[index][fieldName] = selectedOption ? selectedOption.value : ''
            temp[index].Assets = [
                {
                    SuppliedBy: {
                        value: "", label: ""
                    },
                    AssetDetails: [
                        {
                            value: null, label: "", AssetID: null
                        }
                    ],
                    AssetCount: 0
                },

            ]
            setEquipments(temp)
        }
        else if (type === 'house') {
            let temp = [...houses];
            temp[index][fieldName] = selectedOption ? selectedOption.label : null;
            setHouses(temp);
        }

        else if (type === 'houseFitting1') {
            let temp = [...houses];
            temp[index][fieldName] = selectedOption ? selectedOption.label : null;
            setHouses(temp);
        }
        else if (type === 'houseFitting2') {
            let temp = [...houses];
            temp[index][fieldName] = selectedOption ? selectedOption.label : null;
            setHouses(temp);
        }
        else if (type === 'houseSupplied') {
            let temp = [...houses];
            temp[index][fieldName] = selectedOption ? selectedOption : null;
            setHouses(temp);
        }

        else if (type == 'item') {
            let temp = [...items]
            temp[index][fieldName] = selectedOption
            setItems(temp)
        }
        else if (type === 'custom') {
            let temp = [...customPackages];
            temp[index][fieldName] = selectedOption ? selectedOption.value : ''
            setCustomPackages(temp);
        }

        else if (type == 'suppliedBy') {
            let temp = [...equipments]
            temp[index].Assets[fieldName].SuppliedBy = selectedOption
            setEquipments(temp)
        }
        else if (type === "lapSelect") {
            const temp = [...labItems];
            temp[index][fieldName] = selectedOption ? selectedOption.value : ''
            setLabItems(temp);
        }
        else if (type === "hse") {
            const temp = [...hseItems];
            temp[index][fieldName] = selectedOption ? selectedOption.value : '';
            setHseItems(temp);
        }
        else if (type === "hoseType") {
            const temp = [...houses];
            temp[index][fieldName] = selectedOption.label;
            setHouses(temp);
        }
    }

    let handleSuppliedEquipment = (type, selectedOption, equipmentIndex, assetIndex) => {
        let temp = [...equipments];

        if (type === "raNumber") {
            const currentCount = getEquipmentAssetDetailsCount(equipmentIndex);
            const newCount = selectedOption.length;
            const limit = equipments[equipmentIndex].SuppliedQuantity;

            if (newCount > currentCount && currentCount >= limit) {
                return;
            }

            temp[equipmentIndex].Assets[assetIndex].AssetDetails = selectedOption;
            setEquipments(temp);
            return;
        }

        if (type === "basin") {
            temp[equipmentIndex].Assets[assetIndex].SuppliedBy = selectedOption;
            temp[equipmentIndex].Assets[assetIndex].AssetDetails = [];
            temp[equipmentIndex].Assets[assetIndex].assetKey = Date.now();

            setEquipments(temp);
            return;
        }
    };

    const getEquipmentAssetDetailsCount = (equipmentIndex) => {
        return equipments[equipmentIndex].Assets.reduce(
            (sum, asset) => sum + (asset.AssetDetails.filter(a => a.value !== null).length || 0),
            0
        );
    };

    const isEquipmentLimitReached = (equipmentIndex) => {
        return getEquipmentAssetDetailsCount(equipmentIndex) >= equipments[equipmentIndex].SuppliedQuantity;
    };

    let handleDealsChange = (e) => {
        let { name, value } = e.target
        console.log("nna->", name , value)
        setDeals({
            ...deals,
            [name]: value
        })
    }

    let cleanEquipmentOutput = (output) => {
        return output.filter(equipment => {

            // 1️⃣ Check if any main field is filled
            const hasMainFields =
                (equipment.OperationQuantity && Number(equipment.OperationQuantity) > 0) ||
                (equipment.SuppliedQuantity && Number(equipment.SuppliedQuantity) > 0) ||
                !!equipment.Supply_Chain_Asset_Type ||
                !!equipment.AssetType ||
                !!equipment.SalesQuantity;

            // 2️⃣ Check if any Asset has SuppliedBy or valid BCR_ID
            const hasValidAsset = equipment.Assets?.some(asset => {

                const hasSuppliedBy = !!asset.SuppliedBy?.trim();

                const hasValidBCR = asset.AssetDetails?.some(
                    detail => detail.BCR_ID !== null && detail.BCR_ID !== "" && detail.BCR_ID !== undefined
                );

                return hasSuppliedBy || hasValidBCR;
            });

            // 3️⃣ Keep ONLY if something is filled
            return hasMainFields || hasValidAsset;
        });
    }

    let handleSave = async () => {
        let validationPassed = true; // Flag to track validation status
        if (activeTab == 'equipment') {
            /// equipment api call
            const output = equipments.map(item => ({
                EquipmentID: item.equipment_id || null,
                AssetType: item.AssetType || "",
                isSpare: item.isSpare,
                isDeployed: false,
                SalesQuantity: item.SalesQuantity || null,
                OperationQuantity: item.OperationQuantity || null,
                SuppliedQuantity: item.SuppliedQuantity || null,
                Supply_Chain_Asset_Type: item.supplyChainAssetType,
                NonBillableCount: item.NonBillableCount || 0,
                SpareCount: item.SpareCount || 0,
                Notes: item.Notes || "",
                Assets: item.Assets.map(asset => ({
                    SuppliedBy: asset.SuppliedBy?.value || "",
                    AssetDetails: asset.AssetDetails.map(detail => ({
                        AssetID: detail.AssetID || null,
                        BCR_ID: detail.value || null,
                        AssetNo: detail.label || ""
                    }))
                }))
            }));
            for (const equipment of output) {
                const operationQty =
                    equipment.OperationQuantity === 0 ||
                        equipment.OperationQuantity === "0" ||
                        equipment.OperationQuantity === "" ||
                        equipment.OperationQuantity === null ||
                        equipment.OperationQuantity === undefined
                        ? null
                        : Number(equipment.OperationQuantity);

                const opsAssetType =
                    typeof equipment.Supply_Chain_Asset_Type === "string" &&
                        equipment.Supply_Chain_Asset_Type.trim() !== ""
                        ? equipment.Supply_Chain_Asset_Type.trim()
                        : null;

                const hasOperationQuantity = operationQty !== null;
                const hasSupplyChainType = opsAssetType !== null;

                if (hasOperationQuantity !== hasSupplyChainType) {
                    toast.warning(
                        "Operation Quantity and Ops Asset Type are required together.",
                        { autoClose: 8000 }
                    );
                    validationPassed = false;
                    return validationPassed;
                }
            }

            const cleanedData = cleanEquipmentOutput(output);
            if (cleanedData.length === 0) {
                return true;
            }
            if (validationPassed) {
                let payload = {
                    job_id: deals.ID,
                    result: cleanedData
                };
                setShowLoader(true);
                let res = await saveEqipment(localStorage.access_token, payload, countryId);
                setShowLoader(false);
                if (res && res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result.message || "Equipment details saved successfully!");
                } else {
                    toast.error("Failed to save equipment details ❌");
                    validationPassed = false;
                }
            }
        }
        else if (activeTab === 'house') {
            // 1️⃣ Construct the payload
            const payload = {
                job_id: deals.ID,
                items: houses
                    .map(item => ({
                        ID: item.ID ?? null,
                        Hose_Type: item.houseType ?? '',
                        Section_Length: item.sectionLength ?? null,
                        End_Fittings_1: item.endFittingType1 ?? '',
                        End_Fittings_2: item.endFittingType2 ?? '',
                        Quantity: Number(item.quantity) || null,
                        Supplied_By: typeof item.suppliedBy === 'object' ? item.suppliedBy?.value : item.suppliedBy ?? '',
                        Hose_Diameter: Number(item.houseDiameter) || null,
                    }))
                    .filter(obj => Object.values(obj).some(v => v !== null && v !== "" && v !== undefined && v !== 0))

            };
            if (payload.items.length === 0) {
                return true;
            }

            // Add validation for house tab
            const requiredFields = {
                houseType: "House Type",
                houseDiameter: "Hose Diameter",
                sectionLength: "Section Length",
                endFittingType1: "End Fitting Type 1",
                endFittingType2: "End Fitting Type 2",
                // quantity: "Quantity",
                // suppliedBy: "Supplied By"
            };

            let validationPassed = true;

            for (let i = 0; i < houses.length; i++) {
                const item = houses[i];

                // Determine which fields are filled
                const isFilled = {};
                for (const field of Object.keys(requiredFields)) {
                    const val = item[field];
                    isFilled[field] = val !== undefined && val !== null && val !== "";
                }

                // Check if any of the first 6 fields are filled
                const mainFields = ["houseType", "sectionLength", "houseDiameter", "endFittingType1", "endFittingType2"];
                const anyMainFilled = mainFields.some(f => isFilled[f]);

                // If none of the fields are filled → skip validation for this row
                if (!anyMainFilled && !isFilled.suppliedBy) {
                    continue;
                }

                // If at least one main field is filled → validate all 7 fields
                for (const field of Object.keys(requiredFields)) {
                    if (!isFilled[field]) {
                        // toast.warning(`Row ${i + 1}: ${requiredFields[field]} is required`);
                        toast.warning(
                            "Hose Type, Section Length, Hose Diameter, EndFitting Type1, EndFitting Type2  are required ",
                            {
                                autoClose: 8000,
                            }
                        )
                        validationPassed = false;
                        return validationPassed;
                    }
                }
            }
            try {
                setShowLoader(true);
                const res = await saveHose(localStorage?.access_token, payload, countryId);
                setShowLoader(false);

                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result.message || "Hose details saved successfully!");
                } else {
                    toast.error("Failed to save hose details ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                toast.error("Something went wrong while saving hoses.");
                validationPassed = false;
            }
        }
        else if (activeTab == 'items') {
            const isItemInvalid = (item) => {
                const hasQuantity = item?.Quantity > 0;
                const hasSuppliedBy = !!item?.SuppliedBy;
                if (!hasQuantity && !hasSuppliedBy) return false;
                if ((hasQuantity && !hasSuppliedBy) || (!hasQuantity && hasSuppliedBy))
                    return true;
                return false;
            };

            const hasInvalidItems = itemsData?.result?.some(category =>
                (
                    Array.isArray(category.items) &&
                    category.items.some(item => isItemInvalid(item))
                ) ||
                (
                    Array.isArray(category.SubCategory) &&
                    category.SubCategory.some(subCategory =>
                        Array.isArray(subCategory.items) &&
                        subCategory.items.some(item => isItemInvalid(item))
                    )
                )
            )
            // if (hasInvalidItems) {
            //     toast.warning("Both Quantity and Supplied By must be filled or both must be empty.",
            //         {
            //             autoClose: 8000,
            //         }
            //     );
            //     validationPassed = false;
            //     return validationPassed;
            // }

            // Function to extract valid items from any items array
            const extractValidItems = (items) => {
                return (items || [])
                    .filter(item => {
                        const hasQuantity = item.Quantity !== null && item.Quantity !== "" && item.Quantity !== 0;
                        const hasSuppliedBy = item.SuppliedBy !== null && item.SuppliedBy !== "";
                        return hasQuantity || hasSuppliedBy;
                    })
                    .map(item => ({
                        ID: item.ID ?? 0,
                        Item_Details_ID: item.ItemDetailsID ?? 0,
                        Requested_Quantity: item.Quantity ?? 0,
                        Supplied_By: item.SuppliedBy ?? ""
                    }));
            };
            // Process all items from both main categories and subcategories
            const output = itemsData?.result?.flatMap(category => {
                const mainItems = extractValidItems(category.items);
                const subCategoryItems = (category.SubCategory || [])
                    .flatMap(subCategory => extractValidItems(subCategory.items));

                return [...mainItems, ...subCategoryItems];
            });

            let payload = {
                "job_id": deals.ID,
                "items": output || []
            }

            setShowLoader(true);
            let res = await saveItems(localStorage.access_token, payload, countryId)
            setShowLoader(false);
            if (res.status === 200 && res.data?.status_code === 200) {
                toast.success(res.data?.result.message || "Items details saved successfully!");
            } else {
                toast.error("Failed to save items details ❌");
                validationPassed = false;
            }
        }
        else if (activeTab === 'custom') {
            // Add validation for custom tab
            let validationPassed = true;

            const hasInvalidCustomItems = customPackages.some(item => {
                const hasItemName = !!item.itemName?.trim();
                const hasQuantity = item.quantity && Number(item.quantity) > 0;

                const filledCount = [hasItemName, hasQuantity].filter(v => v).length;

                // both empty → OK
                if (filledCount === 0) return false;

                // both filled → OK
                if (filledCount === 2) return false;

                // partially filled → INVALID
                return true;
            });

            if (hasInvalidCustomItems) {
                toast.warning("Item Name and Quantity must be filled together.", {
                    autoClose: 8000,
                });
                validationPassed = false;
                return validationPassed;
            }

            // 1️⃣ Build payload
            const payload = {
                job_id: deals.ID,
                items: customPackages.map(item => ({
                    ID: item.ID ?? 0,
                    Item_Name: item.itemName ?? '',
                    Requested_Quantity: Number(item.quantity) || 0,
                    Supplied_By: item.suppliedBy,
                    Notes: item.notes ?? '',
                })),
            };

            // 2️⃣ Call API
            try {
                setShowLoader(true);
                const res = await saveCustomPackageItems(localStorage?.access_token, payload, countryId);
                setShowLoader(false);
                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(
                        res.data?.result?.message || "Custom packages saved successfully!"
                    );
                } else {
                    toast.error("Failed to save custom packages ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                toast.error("Something went wrong while saving custom packages.");
                validationPassed = false;
            }
        }
        else if (activeTab === "lap") {
            // Add validation for lab tab
            let validationPassed = true;

            const hasInvalidLabItems = labItems.some(item => {
                const hasQuantity = item.quantity && Number(item.quantity) > 0;
                const hasSuppliedBy = !!item.suppliedBy;

                // Fail only when one exists and the other doesn't
                return (hasQuantity && !hasSuppliedBy) || (!hasQuantity && hasSuppliedBy);
            });
            // if (hasInvalidLabItems) {
            //     toast.warning("Both Quantity and Supplied By are required together.");
            //     validationPassed = false;
            //     return validationPassed;
            // }

            const filteredItems = labItems.filter(
                (item) => item.quantity || item.suppliedBy
            );

            const payload = {
                job_id: deals.ID,
                items: filteredItems.map((item) => ({
                    ID: item.ID ?? 0,
                    Lab_Items_ID: item.LabItemsID ?? null,
                    Requested_Quantity: item.quantity ?? 0,
                    Supplied_By: item.suppliedBy ?? "",
                })),
            };

            try {
                setShowLoader(true);
                const res = await saveLabItems(localStorage?.access_token, payload, countryId);
                setShowLoader(false);

                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result?.message || "Lab items saved successfully!");
                } else {
                    toast.error("Failed to save lab items ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                console.error("Error saving lab items:", error);
                toast.error("Something went wrong while saving lab items.");
                validationPassed = false;
            }
        }
        else if (activeTab === 'hse') {
            // Add validation for HSE tab
            let validationPassed = true;
            const hasInvalidHSEItems = hseItems.some(item => {
                const quantity = String(item.quantity || '').trim();
                const suppliedBy = String(item.suppliedBy || '').trim();

                // Both should be filled or both should be empty
                return (quantity && !suppliedBy) || (!quantity && suppliedBy);
            });

            // if (hasInvalidHSEItems) {
            //     toast.warning("Quantity and Supplied By must all be filled together.");
            //     validationPassed = false;
            //     return validationPassed;
            // }

            const filteredItems = hseItems
                .filter(item =>
                    (item.HSEItemID || item.quantity || item.suppliedBy || item.size)
                )
                .map(item => ({
                    ID: item.ID ?? 0,
                    HSE_Items_ID: item.HSEItemID ?? 0,
                    Requested_Quantity: Number(item.quantity) || 0,
                    Supplied_By:
                        typeof item.suppliedBy === 'object'
                            ? item.suppliedBy.value
                            : item.suppliedBy ?? '',
                    // Size: item.size ?? '',
                    Notes: item.Notes
                }))
                .filter(
                    item =>
                        item.Requested_Quantity > 0 ||
                        item.Supplied_By !== ''
                        ||
                        item.Notes !== ''
                );

            const payload = {
                job_id: deals.ID,
                items: filteredItems,
            };

            // 3️⃣ Call API
            try {
                setShowLoader(true);
                const res = await saveHSE(localStorage?.access_token, payload, countryId);
                setShowLoader(false);

                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result?.message || "HSE items saved successfully!");
                } else {
                    toast.error("Failed to save HSE items ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                console.error("Error saving HSE items:", error);
                toast.error("Something went wrong while saving HSE items.");
                validationPassed = false;
            }
        }
        else if (activeTab == '3rdParty') {
            // Add validation for 3rdParty tab
            let validationPassed = true;

            const hasInvalidThirdPartyItems = thirdParty.some(item => {
                const hasQuantity = item.Quantity && Number(item.Quantity) > 0;
                const hasSuppliedBy = !!item.SuppliedBy;

                // Invalid if only one of them is filled
                return (hasQuantity && !hasSuppliedBy) || (!hasQuantity && hasSuppliedBy);
            });

            if (hasInvalidThirdPartyItems) {
                toast.warning("Quantity and Supplied By must be filled together for 3rd party items.");
                validationPassed = false;
                return validationPassed;
            }

            const output = thirdParty
                .map(item => ({
                    ID: item.ID || null,
                    BCR_ID: item.BCR_ID || null,
                    Requested_Quantity: Number(item.Quantity) || null,
                    Supplied_By: item.SuppliedBy || ""
                }))
                .filter(item => !(
                    (item.Requested_Quantity === null || item.Requested_Quantity === 0) &&
                    (item.Supplied_By === null || item.Supplied_By === "")
                ));

            let payload = {
                "job_id": deals.ID,
                "items": output
            }

            setShowLoader(true)
            let res = await save3rdParty(localStorage.access_token, payload, countryId)
            setShowLoader(false)
            if (res.status === 200 && res.data?.status_code === 200) {
                toast.success(res.data?.result?.message || "3rdParty items saved successfully!");
            } else {
                toast.error("Failed to save 3rdParty items ❌");
                validationPassed = false;
            }
        }

        return validationPassed;
    }

    const handleItemsInputChange = (categoryIndex, identifier1, identifier2, field, value, isSubCategory = false) => {
        setItemsData(prevData => {
            const updatedData = {
                ...prevData,
                result: prevData.result.map((category, catIndex) => {
                    if (catIndex === categoryIndex) {
                        // If it's a subcategory item
                        if (isSubCategory && Array.isArray(category.SubCategory)) {
                            const subCategoryIndex = identifier1;
                            const itemIndex = identifier2;

                            return {
                                ...category,
                                SubCategory: category.SubCategory.map((subCategory, subCatIndex) => {
                                    if (subCatIndex === subCategoryIndex) {
                                        return {
                                            ...subCategory,
                                            items: subCategory.items.map((item, idx) => {
                                                if (idx === itemIndex) {
                                                    return {
                                                        ...item,
                                                        [field]: field === 'Quantity' ? parseInt(value) || 0 : value?.value || value
                                                    };
                                                }
                                                return item;
                                            })
                                        };
                                    }
                                    return subCategory;
                                })
                            };
                        }
                        // If it's a main category item
                        else if (!isSubCategory) {
                            const itemIndex = identifier1;

                            return {
                                ...category,
                                items: category.items.map((item, idx) => {
                                    if (idx === itemIndex) {
                                        return {
                                            ...item,
                                            [field]: field === 'Quantity' ? parseInt(value) || 0 : value?.value || value
                                        };
                                    }
                                    return item;
                                })
                            };
                        }
                    }
                    return category;
                })
            };
            return updatedData;
        });
    };

    let updateJobDetails = async () => {
        let payload = {
            "job_id": deals.ID,
            "details": {
                "Needed_On_Site_By": deals.NeededOnSiteBy,
                "Site_Address": deals.SiteAddress,
                "Area_Manager": deals.AreaManager,
                "Field_Leader": deals.FieldLeader,
                "Primary_Basin": deals.PrimaryBasin
            }
        }
        setShowLoader(true)
        let res = await saveJob(localStorage.access_token, payload, countryId)
        setShowLoader(false)
        if (res.status === 200 && res.data?.status_code === 200) {
            toast.success(res.data?.result?.message || "Job details items saved successfully!");
        } else {
            toast.error("Failed to save Job details ❌");
        }

    }

    const handleTablClick = async (tab) => {
        if (!deals?.ID) {
            setActiveTab(tab);
            return
        } else {
            const saveSuccessful = await handleSave();
            if (!saveSuccessful) return;
            setActiveTab(tab);
        }
    };

    let onClose = () => {
        setAssetReset(false)
    }
    let onDeleteClose = () => {
        setAssetDelete(false)
    }
    let onConfirm = (type, selectedOption, index, supplyChain) => {
        setAssetReset(false)
        handleSelectChange(type, selectedOption, index, supplyChain)
    }

    const handleToggle = (index) => {
        setEquipments(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, isSpare: !item.isSpare } : item
            )
        );
    };

    const handleCreateFittingOption = (inputValue, index) => {
        const newOption = {
            label: inputValue.trim(),
            value: inputValue.trim(),
        };
        setFittingOptions(prev => [...prev, newOption]);
        handleSelectChange("houseFitting1", newOption, index, "endFittingType1");
    };

    const handleCreateFittingOption2 = (inputValue, index) => {
        const newOption = {
            label: inputValue.trim(),
            value: inputValue.trim(),
        };
        setFittingOptions(prev => [...prev, newOption]);
        handleSelectChange("houseFitting2", newOption, index, "endFittingType2");
    };
    let hndleEquipmentDelete = async () => {
        setShowLoader(true)
        let payload = {
            equipment_id: equipmentIndexID?.equipment_id
        }
        let res = await deleteEquipment(localStorage.access_token, payload)
        setShowLoader(false)
        if (res?.data && res?.data?.status_code === 200) {
            toast.success(res?.data?.message)
        }
        let temp = [...equipments]
        let updatedData = temp.filter(item => {
            if (item.index !== undefined && item.index !== null) {
                return item.index !== equipmentIndexID.index;
            } else {
                return item.equipment_id !== equipmentIndexID.equipment_id
            }
        });
        setEquipments(updatedData)
    }
    let handleRequestClick = () => {
        navigate('/resupply')
    }
    let handleReDetailsChange = (e, type) => {
        if (type == 'Status' || type == 'priority') {
            setReRequestDetails(prev => ({ ...prev, [type]: e }))
        }
        else {
            let { name, value } = e.target
            setReRequestDetails(prev => ({ ...prev, [name]: value }))
        }

    }
    let handleResupplyRequest = async () => {
        setIsRequesting(true);
        const payload = {
            JobDetails_ID: deals?.ID,
            Needed_On: reRequestDetails.Needed_On,
            Status: statusList.length ? statusList[0].value : 1,
            priority: reRequestDetails.priority.label,
            comments: null
        };
        let res = await postReSupplyRequest(payload, localStorage.access_token);
        setIsRequesting(false);
        if (res && res?.data && res?.data?.data?.status_code == 200) {
            toast.success(res?.data?.data?.message)
            setTimeout(() => {
                navigate(`/home/${deals.ID}/${res?.data?.data?.Request_ID}/${deal_id}/${countryId}`);
            }, 2000);
        }
        else if (res && res?.data && res?.data?.data?.status_code == 403) {
            toast.error(res?.data?.data?.message)
        }
        else if (res && res?.data && res?.data?.data?.status_code == 400) {
            toast.error(res?.data?.data?.message)
        }
        else if (res && res?.data && res?.data?.data?.status_code == 404) {
            toast.error(res?.data?.data?.message)
        }
    };

    const isFormInvalid = !reRequestDetails?.Needed_On || !reRequestDetails?.priority;


    return (
        <>
            <div className="wrapper">
                {showLoader ? <FullScreenLoader></FullScreenLoader> : null}
                <Header />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                    theme="colored"
                />
                <div className="full-assets-mange pt-0">
                    <Container fluid>
                        <Row>
                            <Col xs='12'>
                                <div className="position-relative top-style-head pt-3 pb-3">
                                    <div className="heading-area d-flex flex-wrap align-items-center justify-content-between mb-3">
                                        <div className="d-flex flex-wrap align-items-center">
                                            <h2 className="title-h2 mb-0">{
                                                requestType == 'Resupply' ? 'Resupply Request' : 'Loadout Request'
                                            }</h2>

                                            {/* {
                                                deals?.isDeployed ?
                                                    <span className="status-pill status-pill--deployed ms-2">
                                                        Deployed
                                                    </span>
                                                    :
                                                    false
                                            } */}
                                        </div>
                                        {
                                            requestType == 'Resupply' ?
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-web-resupply-request"
                                                        onClick={() => handleRequestClick()}
                                                    >
                                                        <img src={requestIcon} className="me-2" alt="" />
                                                        Requests List
                                                    </button>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                    <div className="manage-card-bsx mb-4">
                                        <Card className="card-assets-bxs">
                                            <Card.Body className="p-2">
                                                <Row>
                                                    <Col xs={12} md={4} lg={3}>
                                                        <div className="data-flex-nm d-flex align-items-center mb-3 mb-md-0">
                                                            <div className="icon-jb-web"><img src={dataNameIcon} alt="" /></div>
                                                            <div className="manage-grop--wp mb-0 ps-2">
                                                                <h4 className="title-h4-labl">Job Name</h4>
                                                                <p className="shrt-line-txtwts">{deals?.JobName} </p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                        <div className="manage-grop--wp mb-3 mb-md-0">
                                                            <h4 className="title-h4-labl">Customer Name</h4>
                                                            <p className="shrt-line-txtwts">{deals?.CustomerName}</p>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                        <div className="manage-grop--wp mb-0">
                                                            <h4 className="title-h4-labl">Rig/Platform Name </h4>
                                                            <p className="shrt-line-txtwts">{deals?.PlatformName}</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    {
                                        requestType == 'Resupply' ?
                                            <div className="manage-select-elements mb-4">
                                                <Row className="g-3 align-items-end">
                                                    {/* Needed on Site By */}
                                                    <Col xs={12} sm={6} md={3} lg={3}>
                                                        <Form.Group className="mb-0">
                                                            <Form.Label className="label-txt-mange">Needed on Site By</Form.Label>
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    onChange={(e) => handleReDetailsChange(e, 'date')}
                                                                    type="date"
                                                                    className="control-field-txt"
                                                                    name="Needed_On"
                                                                    value={reRequestDetails?.Needed_On || ''}
                                                                />
                                                                <span className="input-icon">
                                                                    <img src={calendarIcon} alt="" />
                                                                </span>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>

                                                    {/* Status */}
                                                    {/* <Col xs={12} sm={6} md={3} lg={3}>
                                                        <Form.Group className="mb-0">
                                                            <Form.Label className="label-txt-mange">Status</Form.Label>
                                                            <div className="position-relative">
                                                                <Select
                                                                    onChange={(e) => handleReDetailsChange(e, 'Status')}
                                                                    className="basic-single"
                                                                    classNamePrefix="select"
                                                                    isClearable={true}
                                                                    isSearchable={true}
                                                                    name="Status"
                                                                    value={statusList.find(opt => opt.value === reRequestDetails?.Status)}
                                                                    options={statusList}
                                                                />
                                                                <span className="input-icon">
                                                                    <img src={fieldIcon} alt="" />
                                                                </span>
                                                            </div>
                                                        </Form.Group>
                                                    </Col> */}

                                                    {/* Priority */}
                                                    <Col xs={12} sm={6} md={3} lg={3}>
                                                        <Form.Group className="mb-0">
                                                            <Form.Label className="label-txt-mange">Priority</Form.Label>
                                                            <div className="position-relative">
                                                                <Select
                                                                    onChange={(e) => handleReDetailsChange(e, 'priority')}
                                                                    className="basic-single"
                                                                    classNamePrefix="select"
                                                                    isClearable={true}
                                                                    isSearchable={true}
                                                                    name="priority"
                                                                    value={priorityOptions.find(opt => opt.value === reRequestDetails?.priority)}
                                                                    options={priorityOptions}
                                                                />
                                                                {/* <span className="input-icon">
                                                                    <img src={fieldIcon} alt="" />
                                                                </span> */}
                                                            </div>
                                                        </Form.Group>
                                                    </Col>

                                                    {/* Request Button */}
                                                    <Col xs={12} sm={6} md={3} lg={3}>
                                                        <div className="d-flex align-items-end h-100">
                                                            <button
                                                                disabled={!deals.ID || isFormInvalid || isRequesting}
                                                                onClick={handleResupplyRequest}
                                                                type="submit"
                                                                className="btn btn-update w-100 btn-resup-request"
                                                            >
                                                                {isRequesting ? 'Requesting...' : 'Request Resupply'}
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>

                                            </div>
                                            :
                                            <div className="manage-select-elements mb-4">
                                                <Row className="less-space-5 align-items-end">
                                                    <Col xs={12} sm={6} md={4} lg={3} xl={2} className="column-filed-grid">
                                                        <div className="form-group-wap mb-3 mb-xl-0">
                                                            <Form.Label className="label-txt-mange">Needed on Site By</Form.Label>
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    // disabled={deals?.isDeployed}
                                                                    onChange={handleDealsChange}
                                                                    type="date"
                                                                    className="control-field-txt"
                                                                    placeholder=""
                                                                    name="NeededOnSiteBy"
                                                                    value={deals?.NeededOnSiteBy ? deals?.NeededOnSiteBy?.split('T')[0] : ''}

                                                                />
                                                                <span className="input-icon"><img src={calendarIcon} alt="" /></span>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col xs={12} sm={6} md={4} lg={3} xl={2} className="column-filed-grid">
                                                        <div className="form-group-wap mb-3 mb-xl-0">
                                                            <Form.Label className="label-txt-mange">Site Address/Coordinaters</Form.Label>
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    onChange={handleDealsChange}
                                                                    type="text"
                                                                    className="control-field-txt"
                                                                    placeholder=""
                                                                    name="SiteAddress"
                                                                    value={deals?.SiteAddress ? deals?.SiteAddress : ''}
                                                                // disabled={deals?.isDeployed}
                                                                />
                                                                <span className="input-icon"><img src={locationIcon} alt="" /></span>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col xs={12} sm={6} md={4} lg={3} xl={2} className="column-filed-grid">
                                                        <div className="form-group-wap mb-3 mb-xl-0">
                                                            <Form.Label className="label-txt-mange">Area Manager Information</Form.Label>
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    onChange={handleDealsChange}
                                                                    type="text"
                                                                    className="control-field-txt"
                                                                    placeholder=""
                                                                    name="AreaManager"
                                                                    value={deals?.AreaManager ? deals?.AreaManager : ''}
                                                                // disabled={deals?.isDeployed}
                                                                />
                                                                <span className="input-icon"><img src={userIcon} alt="" /></span>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col xs={12} sm={6} md={4} lg={3} xl={2} className="column-filed-grid">
                                                        <div className="form-group-wap mb-3 mb-xl-0">
                                                            <Form.Label className="label-txt-mange">Field Leader Information</Form.Label>
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    onChange={handleDealsChange}
                                                                    type="text"
                                                                    className="control-field-txt"
                                                                    placeholder=""
                                                                    name="FieldLeader"
                                                                    value={deals?.FieldLeader ? deals?.FieldLeader : ''}
                                                                // disabled={deals?.isDeployed}
                                                                />
                                                                <span className="input-icon"><img src={fieldIcon} alt="" /></span>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col xs={12} sm={6} md={4} lg={3} xl={2} className="column-filed-grid">
                                                        <div className="form-group-wap mb-3 mb-xl-0">
                                                            <Form.Label className="label-txt-mange">Primary Basin</Form.Label>
                                                            <div className="position-relative">
                                                                <CustomSearchDropdown
                                                                    options={primaryBasinOptions}
                                                                    value={deals?.PrimaryBasin || ''}
                                                                    onChange={handleDealsChange}
                                                                    name="PrimaryBasin"
                                                                    placeholder="Select Primary Basin..."
                                                                    menuStyle={{ zIndex: 99999 }}
                                                                />
                                                                <span className="input-icon">
                                                                    {/* <img src={globalIcon} alt="" /> */}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    
                                                    <Col xs={12} sm={6} md={3} lg={3} xl={2} className="column-filed-grid-update">
                                                        <div className="update-button mb-3 mb-xl-0">
                                                            <button
                                                                // disabled={deals.ID ? deals?.isDeployed : true}
                                                                disabled={deals.ID ? false : true}
                                                                onClick={updateJobDetails}
                                                                type="submit"
                                                                className="btn btn-update"
                                                            >
                                                                <img src={updateIcon} className="me-2" alt="" />
                                                                Update
                                                            </button>
                                                        </div>
                                                    </Col>


                                                </Row>

                                            </div>

                                    }
                                    {
                                        requestType == 'Resupply' ? null :
                                            <div className="box-assets-card">
                                                <div className="multi-buttons-wp d-flex flex-wrap align-items-center justify-content-between">
                                                    <ul className="filter-tab-menu">
                                                        <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('equipment')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'equipment' ? 'active' : ''}`}>Equipment</button></span></li>
                                                        <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('house')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'house' ? 'active' : ''}`}>Hose</button></span></li>
                                                        <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('items')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'items' ? 'active' : ''}`}>Items</button></span></li>
                                                        <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('lap')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'lap' ? 'active' : ''}`}>Lab Items</button></span></li>
                                                        <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('hse')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'hse' ? 'active' : ''}`}>HSE</button></span></li>
                                                        {/* <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('3rdParty')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === '3rdParty' ? 'active' : ''}`}>3rd Party Rental</button></span></li> */}
                                                        <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('custom')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'custom' ? 'active' : ''}`}>Custom Items</button></span></li>
                                                    </ul>
                                                    <div className="summary-view-flx mb-2">
                                                        <button disabled={deals.ID ? false : true} onClick={() => navigate(`/summary/${deal_id}/${deals.ID}/${countryId}`)} class="btn btn-view-summary"><img src={summaryIcon} alt="" className="me-2" />Summary</button>
                                                        <button onClick={handleSave} type="submit" className="btn save-submit-btn ms-2"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                                    </div>
                                                </div>
                                            </div>

                                    }

                                </div>

                                {
                                    requestType == 'Resupply' ?
                                        <div>
                                            <div className="chartlist-card mb-4 mb-lg-5 pb-0">
                                                {/* Improved title with icon and badge */}
                                                <span className="px-4 py-2 bg-light  d-inline-block shadow-sm">
                                                    <i className="bi bi-arrow-repeat me-2"></i>
                                                    <strong>Resupply History</strong>
                                                    <span className="badge bg-primary ms-2 rounded-pill">{historicalRequests.length}</span>
                                                </span>
                                                {isHistoryLoading ? (
                                                    <div className="text-center p-4">Loading historical requests...</div>
                                                ) : (
                                                    <Table responsive className="table-more-asts">
                                                        <thead className="thead-itms-wp" style={{ zIndex: 0 }}>
                                                            <tr>
                                                                <th>Request ID</th>
                                                                <th>Job ID</th>
                                                                {/* <th>Job Name</th> */}
                                                                <th>Request By</th>
                                                                <th>Needed On</th>
                                                                <th>Priority</th>
                                                                <th>Status</th>
                                                                <th>Action</th> {/* Fixed typo */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {historicalRequests.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan="8" className="text-center p-3">
                                                                        No historical resupply requests found.
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                historicalRequests.map((req) => (
                                                                    <tr key={req.Request_ID}>
                                                                        <td>{req.Request_ID}</td>
                                                                        <td>{req.JobDetails_ID}</td>
                                                                        {/* <td>{req.Job_name}</td> */}
                                                                        <td>
                                                                            {req?.Requested_User_Profile?.FirstName} {req?.Requested_User_Profile?.LastName}
                                                                        </td>
                                                                        <td>
                                                                            {req.Needed_On
                                                                                ? new Date(req.Needed_On).toLocaleDateString()
                                                                                : ''}
                                                                        </td>
                                                                        <td>{req.Priority}</td>
                                                                        <td>{req.Status}</td>
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() =>
                                                                                    navigate(
                                                                                        `/home/${req?.JobDetails_ID}/${req?.Request_ID}/${deal_id}/${countryId}`
                                                                                    )
                                                                                }
                                                                            >
                                                                                View
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                )}
                                            </div>
                                        </div>
                                        :
                                        <div className="pb-5">
                                            <div className="table-assets-chart">
                                                {
                                                    activeTab == 'equipment' ?
                                                        <>
                                                            <div className="chartlist-card mb-4 mb-lg-5 pb-0">
                                                                <Table responsive className="table-more-asts">
                                                                    <thead className="thead-itms-wp equipment-table-head">
                                                                        <tr>
                                                                            <th>Sales Asset Type</th>
                                                                            <th className="qty-wth-wps">Sales QTY </th>
                                                                            <th>Ops Asset Type</th>
                                                                            <th className="qty-wth-wps">Ops QTY
                                                                                {/* <span className="tooltips-drop"><img src={exclamationIcon} alt="" /><span className="dropdown-txt-tooltips note-txt-wt">(Note : Only Operation Team can Enter)</span></span> */}
                                                                            </th>
                                                                            <th className="qty-wth-wps">Spare / Non Billable</th>
                                                                            <th className="qty-wth-wps">Supplied QTY</th>
                                                                            <th className="p-0">
                                                                                <div className="th-headarea-s3">
                                                                                    <div className="left-headth">
                                                                                        Supplied By
                                                                                        <span className="tooltips-drop"><img src={exclamationIcon} alt="" />
                                                                                            <span className="dropdown-txt-tooltips note-txt-wt">(Note : Only SCM Team can Enter)</span>
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="right-headth">
                                                                                        Asset Number(s)
                                                                                        <span className="tooltips-drop"><img src={exclamationIcon} alt="" />
                                                                                            <span className="dropdown-txt-tooltips note-txt-wt">(Note : Only SCM Team can Enter)</span>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </th>
                                                                            <th class="note-txt-wt">Notes <span className="tooltips-drop"><img src={exclamationIcon} alt="" /><span className="dropdown-txt-tooltips note-txt-wt">(Note : Only SCM Team can Enter)</span></span></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {equipments.length === 0 ? (
                                                                            <tr>
                                                                                <td colSpan="8" className="text-center p-3">
                                                                                    <button onClick={() => handleAddData('equipment')} type="button" className="btn icon-btn-action">
                                                                                        <img src={plusIcon} alt="Add" />
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ) : (
                                                                            equipments.map((val, index) => {
                                                                                // Get all selected Ops Asset Types from other rows
                                                                                const selectedAssetTypes = equipments
                                                                                    .filter((item, idx) => idx !== index && item.supplyChainAssetType)
                                                                                    .map(item => item.supplyChainAssetType);

                                                                                // Get all selected Asset Numbers from ALL rows
                                                                                const getAllSelectedAssetNumbers = () => {
                                                                                    const allAssetNumbers = new Set();
                                                                                    equipments.forEach((item, idx) => {
                                                                                        item?.Assets?.forEach(asset => {
                                                                                            asset?.AssetDetails?.forEach(detail => {
                                                                                                if (detail?.value) {
                                                                                                    allAssetNumbers.add(detail.value);
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    });
                                                                                    return Array.from(allAssetNumbers);
                                                                                };

                                                                                const selectedAssetNumbers = getAllSelectedAssetNumbers()
                                                                                // Filter options for Ops Asset Type - disable already selected options
                                                                                const getFilteredOptions = () => {
                                                                                    if (val?.AssetSubType?.length) {
                                                                                        return val.AssetSubType.map(option => ({
                                                                                            ...option,
                                                                                            isDisabled: selectedAssetTypes.includes(option.value) &&
                                                                                                option.value !== val.supplyChainAssetType
                                                                                        }));
                                                                                    }

                                                                                    return suppliedChainOptions.map(option => ({
                                                                                        ...option,
                                                                                        isDisabled: selectedAssetTypes.includes(option.value) &&
                                                                                            option.value !== val.supplyChainAssetType
                                                                                    }));
                                                                                };

                                                                                const filteredOptions = getFilteredOptions();

                                                                                // Function to filter asset number options for each asset
                                                                                const getFilteredAssetNumbers = (assetIndex) => {
                                                                                    if (!raNumbers || raNumbers.length === 0) return raNumbers;

                                                                                    // Get currently selected asset numbers in THIS specific asset row
                                                                                    const currentAssetSelectedNumbers = val?.Assets[assetIndex]?.AssetDetails
                                                                                        ?.filter(detail => detail?.value)
                                                                                        .map(detail => detail.value) || [];

                                                                                    return raNumbers.map(option => ({
                                                                                        ...option,
                                                                                        // Disable if selected in ANY row, but allow if it's currently selected in this specific asset
                                                                                        isDisabled: selectedAssetNumbers.includes(option.value) &&
                                                                                            !currentAssetSelectedNumbers.includes(option.value)
                                                                                    }));
                                                                                };

                                                                                return (
                                                                                    <tr key={val.equipment_id}>
                                                                                        <td>
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={
                                                                                                    <Tooltip id={val.AssetType}>
                                                                                                        {val.AssetType ? `${val.AssetType}` : 'N/A'}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <div className="form-group-col sales-type-wth">
                                                                                                    <Form.Control
                                                                                                        disabled
                                                                                                        onChange={(e) => handleInputChange('equipment', e, index)}
                                                                                                        type="text"
                                                                                                        className="input-tb-txt"
                                                                                                        value={val.AssetType}
                                                                                                        name='AssetType'
                                                                                                        placeholder=""
                                                                                                    />
                                                                                                </div>
                                                                                            </OverlayTrigger>
                                                                                        </td>

                                                                                        <td>
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={
                                                                                                    <Tooltip id={val.SalesQuantity}>
                                                                                                        {val.SalesQuantity ? `${val.SalesQuantity}` : 'N/A'}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <div className="form-group-col">
                                                                                                    <Form.Control
                                                                                                        disabled
                                                                                                        type="number"
                                                                                                        onChange={(e) => handleInputChange('equipment', e, index)}
                                                                                                        className="input-tb-txt"
                                                                                                        value={val.SalesQuantity}
                                                                                                        name='SalesQuantity'
                                                                                                        placeholder=""
                                                                                                    />
                                                                                                </div>
                                                                                            </OverlayTrigger>
                                                                                        </td>

                                                                                        <td>
                                                                                            <div className="form-group w-100">
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={`supplychain-tooltip-${index}`}>
                                                                                                            {val.supplyChainAssetType
                                                                                                                ? `${val.supplyChainAssetType}`
                                                                                                                : 'Select input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div style={{ width: "100%", minWidth: "250px" }}>
                                                                                                        <Select
                                                                                                            isDisabled={
                                                                                                                requestType == 'Resupply' ? false :
                                                                                                                    val?.isDeployed == true ? true : false
                                                                                                            }
                                                                                                            isClearable
                                                                                                            classNamePrefix="react-select"
                                                                                                            className="select_itm_fld ops-assets-type-wdt"
                                                                                                            options={filteredOptions}
                                                                                                            value={
                                                                                                                val?.AssetSubType?.length
                                                                                                                    ? val?.AssetSubType.find(
                                                                                                                        (o) => o.value === val.supplyChainAssetType
                                                                                                                    ) || null
                                                                                                                    : suppliedChainOptions.find(
                                                                                                                        (o) => o.value === val.supplyChainAssetType
                                                                                                                    ) || null
                                                                                                            }
                                                                                                            onChange={(selectedOption) => {
                                                                                                                const hasSuppliedBy = val.Assets?.some(
                                                                                                                    (a) => a?.SuppliedBy?.value
                                                                                                                );

                                                                                                                if (!hasSuppliedBy) {
                                                                                                                    onConfirm(
                                                                                                                        "equipment",
                                                                                                                        selectedOption,
                                                                                                                        index,
                                                                                                                        "supplyChainAssetType"
                                                                                                                    );
                                                                                                                    return;
                                                                                                                }

                                                                                                                setPendingSelection({
                                                                                                                    type: 'equipment',
                                                                                                                    selectedOption,
                                                                                                                    index,
                                                                                                                    supplyChain: 'supplyChainAssetType'
                                                                                                                });

                                                                                                                setAssetReset(true);
                                                                                                            }}
                                                                                                            placeholder="Select"
                                                                                                            isSearchable={true}
                                                                                                            menuPortalTarget={document.body}
                                                                                                            menuPosition="absolute"
                                                                                                            styles={{
                                                                                                                control: (base) => ({
                                                                                                                    ...base,
                                                                                                                    borderRadius: "8px",
                                                                                                                    borderColor: "#ccc",
                                                                                                                    minHeight: "38px",
                                                                                                                    width: "100%",
                                                                                                                }),

                                                                                                                valueContainer: (base) => ({
                                                                                                                    ...base,
                                                                                                                    whiteSpace: "normal",
                                                                                                                    overflow: "visible",
                                                                                                                }),

                                                                                                                singleValue: (base) => ({
                                                                                                                    ...base,
                                                                                                                    whiteSpace: "normal",
                                                                                                                    overflow: "visible",
                                                                                                                    textOverflow: "unset",
                                                                                                                    position: "relative",
                                                                                                                    transform: "none",
                                                                                                                    top: "0",
                                                                                                                }),

                                                                                                                menu: (base) => ({
                                                                                                                    ...base,
                                                                                                                    zIndex: 999999,
                                                                                                                }),
                                                                                                            }}
                                                                                                            isOptionDisabled={(option) => option.isDisabled}
                                                                                                        />
                                                                                                    </div>
                                                                                                </OverlayTrigger>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={
                                                                                                    <Tooltip id={val.OperationQuantity}>
                                                                                                        {val.OperationQuantity ? `${val.OperationQuantity}` : 'Enter input'}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <div className="form-group-col">
                                                                                                    <Form.Control
                                                                                                        disabled={
                                                                                                            requestType == 'Resupply' ? false :
                                                                                                                val?.isDeployed == true ? true : false
                                                                                                        }
                                                                                                        type="number"
                                                                                                        onChange={(e) => handleInputChange('opsEquipment', e, index)}
                                                                                                        className="input-tb-txt"
                                                                                                        value={val.OperationQuantity}
                                                                                                        min={0}
                                                                                                        name='OperationQuantity'
                                                                                                        placeholder=""
                                                                                                    />
                                                                                                </div>
                                                                                            </OverlayTrigger>
                                                                                        </td>

                                                                                        <td>
                                                                                            <div className={val.OperationQuantity > val.SalesQuantity ? `spare-box-field` : `spare-box-field-disabled`}>
                                                                                                <div className="input-wave--asts mb-2">
                                                                                                    <span className="text-spare-label light-blue-spare"><div className="dot-circle-spare"></div>Spare</span>
                                                                                                    <div className="spare-bill-ast"><input disabled={requestType == 'Resupply' ? false : val?.isDeployed == true ? true : false} min="0" onChange={(e) => handleInputChange('adEquipment', e, index)} type="number" name="SpareCount" value={val.SpareCount} className="form-control input-bill-ast" /></div>
                                                                                                </div>
                                                                                                <div className="input-wave--asts">
                                                                                                    <span className="text-spare-label light-green-spare"><div className="dot-circle-spare"></div>Non Billable</span>
                                                                                                    <div className="spare-bill-ast"><input disabled={requestType == 'Resupply' ? false : val?.isDeployed == true ? true : false} min="0" onChange={(e) => handleInputChange('adEquipment', e, index)} name="NonBillableCount" value={val.NonBillableCount} type="number" className="form-control input-bill-ast" /></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={
                                                                                                    <Tooltip id={val.SuppliedQuantity}>
                                                                                                        {val.SuppliedQuantity ? `${val.SuppliedQuantity}` : 'Enter input'}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <div className="form-group-col">
                                                                                                    <Form.Control
                                                                                                        disabled={
                                                                                                            requestType == 'Resupply' ? false :
                                                                                                                val?.isDeployed == true ? true : false
                                                                                                        }
                                                                                                        type="number"
                                                                                                        onChange={(e) => handleInputChange('equipment', e, index)}
                                                                                                        className="input-tb-txt"
                                                                                                        value={val.SuppliedQuantity}
                                                                                                        min={0}
                                                                                                        name='SuppliedQuantity'
                                                                                                        placeholder=""
                                                                                                    />
                                                                                                </div>
                                                                                            </OverlayTrigger>
                                                                                        </td>

                                                                                        <td className="px-0">
                                                                                            {val?.Assets.map((ele, i) => {
                                                                                                const filteredAssetNumbers = getFilteredAssetNumbers(i);
                                                                                                return (
                                                                                                    <div className="d-flex less-margin-8" key={`${val.supplyChainAssetType}-${index}-${i}`}>
                                                                                                        <div className="form-group-col select-supp-left">
                                                                                                            <OverlayTrigger
                                                                                                                placement="top"
                                                                                                                overlay={
                                                                                                                    <Tooltip id={ele?.SuppliedBy?.value}>
                                                                                                                        {ele?.SuppliedBy?.value ? `${ele?.SuppliedBy?.value}` : 'Select input'}
                                                                                                                    </Tooltip>
                                                                                                                }
                                                                                                            >
                                                                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                                                                    <Select
                                                                                                                        key={`supplied-by-${val.supplyChainAssetType}-${index}-${i}`}
                                                                                                                        classNamePrefix="react-select"
                                                                                                                        className="single-select-optn select_itm_fld"
                                                                                                                        options={
                                                                                                                            isBasinLoading
                                                                                                                                ? [{ label: "Loading...", value: "", isDisabled: true }]
                                                                                                                                : basins
                                                                                                                        }
                                                                                                                        isClearable={true}
                                                                                                                        value={ele?.SuppliedBy?.value ? { label: ele.SuppliedBy.label, value: ele.SuppliedBy.value } : null}
                                                                                                                        onMenuOpen={() => fetchBasins(val?.supplyChainAssetType)}
                                                                                                                        placeholder="Select"
                                                                                                                        onChange={(selectedOption) =>
                                                                                                                            handleSuppliedEquipment('basin', selectedOption, index, i)
                                                                                                                        }
                                                                                                                        isSearchable={true}
                                                                                                                        isDisabled={requestType == 'Resupply' ? false : val?.isDeployed || isEquipmentLimitReached(index)}
                                                                                                                        menuPortalTarget={document.body}
                                                                                                                        menuPosition="absolute"
                                                                                                                        styles={{
                                                                                                                            control: (base) => ({
                                                                                                                                ...base,
                                                                                                                                borderRadius: "8px",
                                                                                                                                borderColor: "#ccc",
                                                                                                                                minHeight: "38px",
                                                                                                                            }),
                                                                                                                            menu: (base) => ({
                                                                                                                                ...base,
                                                                                                                                zIndex: 1,
                                                                                                                            }),
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </OverlayTrigger>
                                                                                                        </div>

                                                                                                        <div className="form-group-col select-supp-right d-flex" style={{ width: '100%', minWidth: 0 }}>
                                                                                                            <div className="select-assets-number" style={{ flex: 1, minWidth: 0, width: '100%' }}>
                                                                                                                <CustomMultiSelectDropdown
                                                                                                                    key={`asset-details-${val.supplyChainAssetType}-${index}-${i}-${ele.assetKey || 0}`}
                                                                                                                    className="inside-border-inpt select_itm_fld"
                                                                                                                    options={isBasinLoading ? [{ label: "Loading...", value: "", isDisabled: true }] : filteredAssetNumbers}
                                                                                                                    value={(ele?.AssetDetails || []).filter((item) => item?.value && item?.label)}
                                                                                                                    onChange={(selectedOptions) => handleSuppliedEquipment('raNumber', selectedOptions, index, i)}
                                                                                                                    onMenuOpen={() => fetchRsNumber(val?.supplyChainAssetType, ele?.SuppliedBy?.value, index, i)}
                                                                                                                    placeholder="Select"
                                                                                                                    isSearchable
                                                                                                                    isDisabled={requestType == 'Resupply' ? false : val?.isDeployed || isEquipmentLimitReached(index)}
                                                                                                                    isLoading={isBasinLoading}
                                                                                                                    menuPosition="absolute"
                                                                                                                    // Pass isOptionDisabled prop if CustomMultiSelectDropdown supports it
                                                                                                                    isOptionDisabled={(option) => option.isDisabled}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div className="assets-number-s" style={{
                                                                                                                flexShrink: 0,
                                                                                                                marginLeft: '8px',
                                                                                                                minWidth: 'fit-content'
                                                                                                            }}>
                                                                                                                {i == 0 ?
                                                                                                                    val.SuppliedQuantity ? (
                                                                                                                        <span
                                                                                                                            key={index}
                                                                                                                            className={
                                                                                                                                getEquipmentAssetDetailsCount(index) == val.SuppliedQuantity
                                                                                                                                    ? 'btn-numb-wpm-f'
                                                                                                                                    : 'btn-numb-wpm'
                                                                                                                            }
                                                                                                                        >
                                                                                                                            {`${getEquipmentAssetDetailsCount(index)}/${val.SuppliedQuantity}`}
                                                                                                                        </span>
                                                                                                                    ) : (
                                                                                                                        <span className="btn-numb-wpm-1"></span>
                                                                                                                    )
                                                                                                                    :
                                                                                                                    <span className="btn-numb-wpm-1"></span>
                                                                                                                }
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </td>
                                                                                        <td>
                                                                                            <div className="d-flex align-items-center">
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={val.Notes}>
                                                                                                            {val.Notes ? `${val.Notes}` : 'Enter input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="form-grop-notes-flx">
                                                                                                        <Form.Control
                                                                                                            disabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                            type="text"
                                                                                                            onChange={(e) => handleInputChange('equipment', e, index)}
                                                                                                            className="input-tb-txt"
                                                                                                            value={val.Notes}
                                                                                                            name='Notes'
                                                                                                            placeholder=""
                                                                                                        />
                                                                                                    </div>
                                                                                                </OverlayTrigger>
                                                                                                {
                                                                                                    // !deals?.isDeployed ?
                                                                                                    <div className="d-flex align-items-center button-wt-action notes-butn-wts">
                                                                                                        {/* {
                                                                                                    !val.isDeployed && (index !== 0 || isEquipmentRowEmpty(val)) && (
                                                                                                        <button onClick={() => handleRemoveData('equipment', val)} type="button" className="btn icon-btn-action">
                                                                                                            <img src={minusIcon} alt="icon" />
                                                                                                        </button>
                                                                                                    )
                                                                                                } */}

                                                                                                        {
                                                                                                            !val.isDeployed ?
                                                                                                                <button onClick={() => handleRemoveData('equipment', val)} type="button" className="btn icon-btn-action">
                                                                                                                    <img src={minusIcon} alt="icon" />
                                                                                                                </button>
                                                                                                                :
                                                                                                                null

                                                                                                        }
                                                                                                        {
                                                                                                            index == equipments.length - 1 ?
                                                                                                                <button onClick={() => handleAddData('equipment', val.index)} type="button" className="btn icon-btn-action">
                                                                                                                    <img src={plusIcon} alt="icon" />
                                                                                                                </button>
                                                                                                                :
                                                                                                                null
                                                                                                        }

                                                                                                    </div>

                                                                                                    // :
                                                                                                    // null
                                                                                                }

                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                            <div className="total-qty-footer d-flex flex-wrap align-items-center justify-content-between">
                                                                <div className="total-ft-wth">
                                                                    <span className="txt-label-ttl">
                                                                        Total Sales QTY{" "}
                                                                        <span className="d-inline-block ms-2">{equipments?.reduce((sum, e) => sum + Number(e.SalesQuantity ?? 0), 0)}</span>
                                                                    </span>
                                                                    <span className="txt-label-ttl">
                                                                        Total Operation QTY
                                                                        <span className="d-inline-block ms-2">
                                                                            {
                                                                                equipments?.reduce(
                                                                                    (sum, e) => sum + (Number(e.OperationQuantity) || 0),
                                                                                    0
                                                                                )
                                                                            }
                                                                        </span>
                                                                    </span>
                                                                    <span className="txt-label-ttl">
                                                                        Total Supplied QTY{" "}
                                                                        <span className="d-inline-block ms-2">
                                                                            {
                                                                                equipments?.reduce(
                                                                                    (sum, e) => sum + Number(e.SuppliedQuantity ?? 0),
                                                                                    0
                                                                                )
                                                                            }
                                                                        </span>

                                                                    </span>
                                                                </div>

                                                                <div className="d-flex justify-content-end ps-md-3 mt-3 mt-md-0">
                                                                    <button onClick={handleSave} type="submit" className="btn save-submit-btn"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        activeTab === 'house' ?
                                                            <>
                                                                <div className="chartlist-card mb-4 mb-lg-5 pb-0">
                                                                    <Table responsive className="table-more-asts">
                                                                        <thead className="thead-itms-wp">
                                                                            <tr>
                                                                                <th>Hose Type</th>
                                                                                <th>Hose Diameter <span className="small-th-head">( Inches)</span></th>
                                                                                <th>Section Length <span className="small-th-head">(Feet)</span></th>
                                                                                <th>End-Fitting Type 1</th>
                                                                                <th>End-Fitting Type 2</th>
                                                                                <th>Quantity</th>
                                                                                <th>Supplied By</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {houses.length === 0 ? (
                                                                                <tr>
                                                                                    <td colSpan="7" className="text-center p-3">
                                                                                        <button onClick={() => handleAddData('house')} type="button" className="btn icon-btn-action">
                                                                                            <img src={plusIcon} alt="Add" />
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ) : (
                                                                                houses.map((val, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <td>
                                                                                                <div className="form-group-col">
                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={val.houseType}>
                                                                                                                {val.houseType ? `${val.houseType}` : 'Select input'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <div class="hose-select-wps">

                                                                                                            <CreatableSelect
                                                                                                                isDisabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                                classNamePrefix="react-select"
                                                                                                                className="select_itm_fld"
                                                                                                                options={housesOptions}
                                                                                                                value={
                                                                                                                    housesOptions.find(o => o.label === val.houseType)
                                                                                                                    || (val.houseType ? { label: val.houseType, value: val.houseType } : null)
                                                                                                                }

                                                                                                                onChange={(selectedOption) =>
                                                                                                                    handleSelectChange("house", selectedOption, index, "houseType")
                                                                                                                }
                                                                                                                onCreateOption={(inputValue) => handleCreateHouseOption(inputValue, index)}
                                                                                                                placeholder="Select or create..."
                                                                                                                isSearchable
                                                                                                                isClearable
                                                                                                                menuPortalTarget={document.body}
                                                                                                                menuPosition="absolute"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                    {/* <Form.Control type="text" className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='houseType' value={val.houseType} placeholder="" /> */}
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={val.houseDiameter}>
                                                                                                            {val.houseDiameter ? `${val.houseDiameter}` : 'Enter input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="form-group-col">
                                                                                                        <Form.Control disabled={requestType == 'Resupply' ? false : val?.isDeployed} type="number" min={0} className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='houseDiameter' value={val.houseDiameter} placeholder="" />
                                                                                                    </div>
                                                                                                </OverlayTrigger>
                                                                                            </td>
                                                                                            <td>
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={val.sectionLength}>
                                                                                                            {val.sectionLength ? `${val.sectionLength}` : 'Enter input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="form-group-col">
                                                                                                        <Form.Control disabled={requestType == 'Resupply' ? false : val?.isDeployed} type="number" min={0} className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='sectionLength' value={val.sectionLength} placeholder="" />
                                                                                                    </div>

                                                                                                </OverlayTrigger>
                                                                                            </td>
                                                                                            <td>
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={val.endFittingType1}>
                                                                                                            {val.endFittingType1 ? `${val.endFittingType1}` : 'Enter input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="form-group-col">
                                                                                                        {/* <Form.Control type="text" className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='endFittingType1' value={val.endFittingType1} placeholder="" /> */}
                                                                                                        <CreatableSelect
                                                                                                            isDisabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                            classNamePrefix="react-select"
                                                                                                            className="select_itm_fld"
                                                                                                            options={fittingOptions}
                                                                                                            value={
                                                                                                                fittingOptions.find(o => o.label === val.endFittingType1) ||
                                                                                                                (val.endFittingType1
                                                                                                                    ? { label: val.endFittingType1, value: val.endFittingType1 }
                                                                                                                    : null)
                                                                                                            }
                                                                                                            onChange={(selectedOption) =>
                                                                                                                handleSelectChange("houseFitting1", selectedOption, index, "endFittingType1")
                                                                                                            }
                                                                                                            onCreateOption={(inputValue) =>
                                                                                                                handleCreateFittingOption(inputValue, index)
                                                                                                            }
                                                                                                            placeholder="Select or create..."
                                                                                                            isSearchable
                                                                                                            isClearable
                                                                                                            menuPortalTarget={document.body}
                                                                                                            menuPosition="absolute"
                                                                                                        />
                                                                                                    </div>
                                                                                                </OverlayTrigger>
                                                                                            </td>
                                                                                            <td>
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={val.endFittingType2}>
                                                                                                            {val.endFittingType2 ? `${val.endFittingType2}` : 'Enter input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="form-group-col">
                                                                                                        {/* <Form.Control type="text" className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='endFittingType2' value={val.endFittingType2} placeholder="" /> */}

                                                                                                        <CreatableSelect
                                                                                                            isDisabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                            classNamePrefix="react-select"
                                                                                                            className="select_itm_fld"
                                                                                                            options={fittingOptions}
                                                                                                            value={
                                                                                                                fittingOptions.find(o => o.label === val.endFittingType2) ||
                                                                                                                (val.endFittingType2
                                                                                                                    ? { label: val.endFittingType2, value: val.endFittingType2 }
                                                                                                                    : null)
                                                                                                            }
                                                                                                            onChange={(selectedOption) =>
                                                                                                                handleSelectChange("houseFitting2", selectedOption, index, "endFittingType2")
                                                                                                            }
                                                                                                            onCreateOption={(inputValue) =>
                                                                                                                handleCreateFittingOption2(inputValue, index)
                                                                                                            }
                                                                                                            placeholder="Select or create..."
                                                                                                            isSearchable
                                                                                                            isClearable
                                                                                                            menuPortalTarget={document.body}
                                                                                                            menuPosition="absolute"
                                                                                                        />
                                                                                                    </div>
                                                                                                </OverlayTrigger>
                                                                                            </td>
                                                                                            <td>
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={val.quantity}>
                                                                                                            {val.quantity ? `${val.quantity}` : 'Enter input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="form-group-col">
                                                                                                        <Form.Control disabled={requestType == 'Resupply' ? false : val?.isDeployed} type="number" min={0} className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='quantity' value={val.quantity} placeholder="" />
                                                                                                    </div>
                                                                                                </OverlayTrigger>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div className="d-flex align-items-center">

                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={val?.suppliedBy?.value}>
                                                                                                                {val?.suppliedBy?.value ? `${val.suppliedBy?.value}` : 'Select input'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <div className="form-group-col select-supp-by-wth">
                                                                                                            <Select
                                                                                                                isDisabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                                isClearable
                                                                                                                classNamePrefix="react-select"
                                                                                                                className="select_itm_fld"
                                                                                                                options={basinsOptions}
                                                                                                                value={val.suppliedBy}
                                                                                                                onChange={(selectedOption) => handleSelectChange('houseSupplied', selectedOption, index, 'suppliedBy')}
                                                                                                                placeholder="Select"
                                                                                                                isSearchable={true}
                                                                                                                menuPortalTarget={document.body}
                                                                                                                menuPosition="absolute"
                                                                                                                styles={{
                                                                                                                    control: (base) => ({
                                                                                                                        ...base,
                                                                                                                        borderRadius: "8px",
                                                                                                                        borderColor: "#ccc",
                                                                                                                        minHeight: "38px",
                                                                                                                    }),
                                                                                                                    menu: (base) => ({
                                                                                                                        ...base,
                                                                                                                        zIndex: 9999,
                                                                                                                    }),
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                    {

                                                                                                        <div className="d-flex align-items-center button-wt-action">
                                                                                                            {
                                                                                                                !val.isDeployed && (index !== 0 || isHoseRowEmpty(val)) && (
                                                                                                                    <button onClick={() => handleRemoveData('house', val)} type="button" className="btn icon-btn-action"><img src={minusIcon} alt="icon" /></button>
                                                                                                                )
                                                                                                            }
                                                                                                            {
                                                                                                                index == houses.length - 1 ?
                                                                                                                    <button onClick={() => handleAddData('house', val.index)} type="button" className="btn icon-btn-action"><img src={plusIcon} alt="icon" /></button>
                                                                                                                    :
                                                                                                                    null

                                                                                                            }

                                                                                                        </div>

                                                                                                    }

                                                                                                </div>

                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            )}

                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                                <div className="total-qty-footer d-flex flex-wrap align-items-center justify-content-between">
                                                                    <div className="total-ft-wth">
                                                                        <span class="txt-label-ttl">Total QTY <span className="d-inline-block ms-3"></span>{
                                                                            houses.reduce((sum, e) => sum + Number(e.quantity), 0)
                                                                        }</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-end ps-md-3 mt-3 mt-md-0">
                                                                        <button onClick={handleSave} type="submit" className="btn save-submit-btn"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            activeTab === 'items' ?
                                                                <>
                                                                    <div className="mb-4 mb-lg-5">
                                                                        <div className="table-accordion-assets" style={{ overflow: 'visible' }}>
                                                                            <Accordion>
                                                                                {itemsData?.result?.map((category, categoryIndex) => (
                                                                                    <Accordion.Item
                                                                                        key={categoryIndex}
                                                                                        className="accordion-card-itm"
                                                                                        eventKey={categoryIndex.toString()}
                                                                                    >
                                                                                        <Accordion.Header className="heading-accordian-wp">
                                                                                            {category.MasterCategory}
                                                                                        </Accordion.Header>
                                                                                        <Accordion.Body className="p-0">
                                                                                            {Array.isArray(category.SubCategory) && category.SubCategory.length > 0 ? (
                                                                                                <Accordion>
                                                                                                    {category.SubCategory.map((subCategory, subCategoryIndex) => (
                                                                                                        <Accordion.Item
                                                                                                            key={subCategoryIndex}
                                                                                                            className="item-accordian-lst"
                                                                                                            eventKey={subCategoryIndex.toString()}
                                                                                                        >
                                                                                                            <Accordion.Header>{subCategory.MasterCategory}</Accordion.Header>
                                                                                                            <Accordion.Body className="p-0">
                                                                                                                <Table responsive className="table-more-asts" style={{ overflow: 'visible' }}>
                                                                                                                    <thead className="thead-itms-wp items-headwp">
                                                                                                                        <tr>
                                                                                                                            <th>Item Name</th>
                                                                                                                            <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                                                                            <th className="item-suplywgt-head">Supplied By</th>
                                                                                                                        </tr>
                                                                                                                    </thead>
                                                                                                                    <tbody>
                                                                                                                        {subCategory.items?.map((item, itemIndex) => (
                                                                                                                            <tr key={itemIndex}>
                                                                                                                                <td>
                                                                                                                                    <OverlayTrigger
                                                                                                                                        placement="top"
                                                                                                                                        overlay={
                                                                                                                                            <Tooltip id={item.ItemName}>
                                                                                                                                                {item.ItemName ? `${item.ItemName}` : 'N/A'}
                                                                                                                                            </Tooltip>
                                                                                                                                        }
                                                                                                                                    >
                                                                                                                                        <div className="itm-content-parg">
                                                                                                                                            <p className="txtweb-content">{item.ItemName}</p>
                                                                                                                                        </div>
                                                                                                                                    </OverlayTrigger>
                                                                                                                                </td>
                                                                                                                                <td>
                                                                                                                                    <OverlayTrigger
                                                                                                                                        placement="top"
                                                                                                                                        overlay={
                                                                                                                                            <Tooltip id={item.Quantity}>
                                                                                                                                                {item.Quantity ? `${item.Quantity}` : 'Enter input'}
                                                                                                                                            </Tooltip>
                                                                                                                                        }
                                                                                                                                    >
                                                                                                                                        <div className="form-group-col">
                                                                                                                                            <Form.Control
                                                                                                                                                disabled={requestType == 'Resupply' ? false : item?.isdeployed}
                                                                                                                                                type="number"
                                                                                                                                                onChange={(e) => handleItemsInputChange(
                                                                                                                                                    categoryIndex,
                                                                                                                                                    subCategoryIndex,
                                                                                                                                                    itemIndex,
                                                                                                                                                    'Quantity',
                                                                                                                                                    e.target.value,
                                                                                                                                                    true
                                                                                                                                                )}
                                                                                                                                                className="input-tb-txt"
                                                                                                                                                name='quantity'
                                                                                                                                                min={0}
                                                                                                                                                value={item.Quantity ?? ''}
                                                                                                                                                placeholder=""
                                                                                                                                            />
                                                                                                                                        </div>
                                                                                                                                    </OverlayTrigger>
                                                                                                                                </td>
                                                                                                                                <td>
                                                                                                                                    <OverlayTrigger
                                                                                                                                        placement="top"
                                                                                                                                        overlay={
                                                                                                                                            <Tooltip id={item.SuppliedBy}>
                                                                                                                                                {item.SuppliedBy ? `${item.SuppliedBy}` : 'Select input'}
                                                                                                                                            </Tooltip>
                                                                                                                                        }
                                                                                                                                    >
                                                                                                                                        <div className="d-flex align-items-center">
                                                                                                                                            <div className="itm-select-supply-wtm" style={{ width: '100%' }}>
                                                                                                                                                <Select
                                                                                                                                                    // menuPlacement="bottom"
                                                                                                                                                    isDisabled={requestType == 'Resupply' ? false : item?.isdeployed}
                                                                                                                                                    isClearable
                                                                                                                                                    classNamePrefix="react-select"
                                                                                                                                                    className="select-wgt-grt"
                                                                                                                                                    options={basinsOptions}
                                                                                                                                                    value={basinsOptions.find(option => option.value === item.SuppliedBy) || null}
                                                                                                                                                    onChange={(value) => handleItemsInputChange(
                                                                                                                                                        categoryIndex,
                                                                                                                                                        subCategoryIndex,
                                                                                                                                                        itemIndex,
                                                                                                                                                        'SuppliedBy',
                                                                                                                                                        value,
                                                                                                                                                        true
                                                                                                                                                    )}
                                                                                                                                                    placeholder="Select"
                                                                                                                                                    isSearchable={true}
                                                                                                                                                    menuPortalTarget={document.body}
                                                                                                                                                    menuPosition="absolute"
                                                                                                                                                    styles={{
                                                                                                                                                        control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                                                                                    }}
                                                                                                                                                />
                                                                                                                                            </div>
                                                                                                                                        </div>
                                                                                                                                    </OverlayTrigger>
                                                                                                                                </td>
                                                                                                                            </tr>
                                                                                                                        ))}
                                                                                                                    </tbody>
                                                                                                                </Table>
                                                                                                            </Accordion.Body>
                                                                                                        </Accordion.Item>
                                                                                                    ))}
                                                                                                </Accordion>
                                                                                            ) : (
                                                                                                <Table responsive className="table-more-asts" style={{ overflow: 'visible' }}>
                                                                                                    <thead className="thead-itms-wp items-headwp">
                                                                                                        <tr>
                                                                                                            <th>Item Name</th>
                                                                                                            <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                                                            <th className="item-suplywgt-head">Supplied By</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        {category.items?.map((item, itemIndex) => (
                                                                                                            <tr key={itemIndex}>
                                                                                                                <td>
                                                                                                                    <OverlayTrigger
                                                                                                                        placement="top"
                                                                                                                        overlay={
                                                                                                                            <Tooltip id={item.ItemName}>
                                                                                                                                {item.ItemName ? `${item.ItemName}` : 'N/A'}
                                                                                                                            </Tooltip>
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <div className="itm-content-parg">
                                                                                                                            <p className="txtweb-content">{item.ItemName}</p>
                                                                                                                        </div>
                                                                                                                    </OverlayTrigger>
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <OverlayTrigger
                                                                                                                        placement="top"
                                                                                                                        overlay={
                                                                                                                            <Tooltip id={item.Quantity}>
                                                                                                                                {item.Quantity ? `${item.Quantity}` : 'Enter input'}
                                                                                                                            </Tooltip>
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <div className="form-group-col">
                                                                                                                            <Form.Control
                                                                                                                                disabled={requestType == 'Resupply' ? false : item?.isdeployed}
                                                                                                                                type="number"
                                                                                                                                min={0}
                                                                                                                                onChange={(e) => handleItemsInputChange(
                                                                                                                                    categoryIndex,
                                                                                                                                    itemIndex,
                                                                                                                                    null,
                                                                                                                                    'Quantity',
                                                                                                                                    e.target.value
                                                                                                                                )}
                                                                                                                                className="input-tb-txt"
                                                                                                                                name='quantity'
                                                                                                                                value={item.Quantity ?? ''}
                                                                                                                                placeholder=""
                                                                                                                            />
                                                                                                                        </div>
                                                                                                                    </OverlayTrigger>
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <OverlayTrigger
                                                                                                                        placement="top"
                                                                                                                        overlay={
                                                                                                                            <Tooltip id={item.SuppliedBy}>
                                                                                                                                {item.SuppliedBy ? `${item.SuppliedBy}` : 'Select input'}
                                                                                                                            </Tooltip>
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <div className="d-flex align-items-center">
                                                                                                                            <div className="itm-select-supply-wtm" style={{ width: '100%' }}>
                                                                                                                                <Select
                                                                                                                                    isDisabled={requestType == 'Resupply' ? false : item?.isdeployed}
                                                                                                                                    isClearable
                                                                                                                                    classNamePrefix="react-select"
                                                                                                                                    className="select-wgt-grt select_itm_fld"
                                                                                                                                    options={basinsOptions}
                                                                                                                                    value={basinsOptions.find(option => option.value === item.SuppliedBy) || null}
                                                                                                                                    onChange={(value) => handleItemsInputChange(
                                                                                                                                        categoryIndex,
                                                                                                                                        itemIndex,
                                                                                                                                        null,
                                                                                                                                        'SuppliedBy',
                                                                                                                                        value
                                                                                                                                    )}
                                                                                                                                    placeholder="Select"
                                                                                                                                    isSearchable={true}
                                                                                                                                    menuPortalTarget={document.body}
                                                                                                                                    menuPosition="absolute"
                                                                                                                                    styles={{
                                                                                                                                        control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </OverlayTrigger>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        ))}
                                                                                                    </tbody>
                                                                                                </Table>
                                                                                            )}
                                                                                        </Accordion.Body>
                                                                                    </Accordion.Item>
                                                                                ))}
                                                                            </Accordion>
                                                                        </div>
                                                                    </div>
                                                                    <div className="total-qty-footer d-flex flex-wrap align-items-center justify-content-end">
                                                                        <div className="d-flex justify-content-end ps-md-3 mt-3 mt-md-0">
                                                                            <button onClick={handleSave} type="submit" className="btn save-submit-btn"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                activeTab === 'custom' ?
                                                                    <>
                                                                        <div className="mb-4 mb-lg-5">
                                                                            <Table responsive className="table-more-asts">
                                                                                <thead className="thead-itms-wp">
                                                                                    <tr>
                                                                                        <th>Item Name</th>
                                                                                        <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                                        <th className="supply-by-thead">Supplied By</th>
                                                                                        <th>Notes</th>
                                                                                        <th></th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody className="td-align-wt">
                                                                                    {customPackages.length === 0 ? (
                                                                                        <tr>
                                                                                            <td colSpan="5" className="text-center p-3">
                                                                                                <button onClick={() => handleAddData('custom')} type="button" className="btn icon-btn-action">
                                                                                                    <img src={plusIcon} alt="Add" />
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ) : (
                                                                                        customPackages.map((val, index) => (
                                                                                            <tr key={val.index}>
                                                                                                <td>
                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={val.itemName}>
                                                                                                                {val.itemName ? `${val.itemName}` : 'Enter input'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <Form.Control
                                                                                                            disabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                            type="text"
                                                                                                            name="itemName"
                                                                                                            className="input-tb-txt"
                                                                                                            value={val.itemName}
                                                                                                            onChange={(e) => handleInputChange("custom", e, index)}
                                                                                                        />
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={val.quantity}>
                                                                                                                {val.quantity ? `${val.quantity}` : 'Enter input'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <Form.Control
                                                                                                            disabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                            type="number"
                                                                                                            min={0}
                                                                                                            name="quantity"
                                                                                                            className="input-tb-txt"
                                                                                                            value={val.quantity}
                                                                                                            onChange={(e) => handleInputChange("custom", e, index)}
                                                                                                        />

                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={val.suppliedBy}>
                                                                                                                {val.suppliedBy ? `${val.suppliedBy}` : 'Select input'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <div>
                                                                                                            <Select
                                                                                                                isDisabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                                isClearable
                                                                                                                classNamePrefix="react-select"
                                                                                                                className="select_itm_fld"
                                                                                                                options={basinsOptions}
                                                                                                                value={basinsOptions.find(opt => opt.value === val.suppliedBy) || null}
                                                                                                                onChange={(selectedOption) => handleSelectChange('custom', selectedOption, index, 'suppliedBy')}
                                                                                                                placeholder="Select"
                                                                                                                isSearchable={true}
                                                                                                                menuPortalTarget={document.body}
                                                                                                                menuPosition="absolute"
                                                                                                                styles={{
                                                                                                                    control: (base) => ({
                                                                                                                        ...base,
                                                                                                                        borderRadius: "8px",
                                                                                                                        borderColor: "#ccc",
                                                                                                                        minHeight: "38px",
                                                                                                                    }),
                                                                                                                    menu: (base) => ({
                                                                                                                        ...base,
                                                                                                                        zIndex: 9999,
                                                                                                                    }),
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={val.notes}>
                                                                                                                {val.notes ? `${val.notes}` : 'Enter input'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <Form.Control
                                                                                                            disabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                            type="text"
                                                                                                            name="notes"
                                                                                                            value={val.notes}
                                                                                                            className="input-tb-txt"
                                                                                                            onChange={(e) => handleInputChange("custom", e, index)}
                                                                                                        />
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                {

                                                                                                    <td>
                                                                                                        <div class="d-flex">
                                                                                                            {
                                                                                                                !val.isDeployed && (
                                                                                                                    <button onClick={() => handleRemoveData("custom", val)} type="button" className="btn icon-btn-action"><img src={minusIcon} alt="icon" /></button>
                                                                                                                )
                                                                                                            }
                                                                                                            {
                                                                                                                index == customPackages.length - 1 ?
                                                                                                                    <button onClick={() => handleAddData("custom", index)} type="button" className="btn icon-btn-action"><img src={plusIcon} alt="icon" /></button>
                                                                                                                    :
                                                                                                                    null

                                                                                                            }

                                                                                                        </div>
                                                                                                    </td>

                                                                                                }

                                                                                            </tr>
                                                                                        ))
                                                                                    )}
                                                                                </tbody>

                                                                            </Table>
                                                                        </div>
                                                                        <div className="total-qty-footer d-flex flex-wrap align-items-center justify-content-between">
                                                                            <div className="total-ft-wth">
                                                                                <span class="txt-label-ttl">Total QTY <span className="d-inline-block ms-3"></span>{
                                                                                    customPackages.reduce((sum, e) => sum + Number(e.quantity), 0)
                                                                                }</span>
                                                                            </div>
                                                                            <div className="d-flex justify-content-end ps-md-3 mt-3 mt-md-0">
                                                                                <button type="submit" onClick={handleSave} className="btn save-submit-btn"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    activeTab === 'lap' ?
                                                                        <>
                                                                            <div className="mb-4 mb-lg-5">
                                                                                <Table responsive className="table-more-asts">
                                                                                    <thead className="thead-itms-wp">
                                                                                        <tr>
                                                                                            <th>Item Name</th>
                                                                                            <th className="qnty-reqsr-web">Quantity (Requested)</th>
                                                                                            <th className="supply-by-lab">Supplied By</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody className="td-align-wt">
                                                                                        {labItems.map((item, index) => (
                                                                                            <tr key={index}>
                                                                                                <td>
                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={item.itemName}>
                                                                                                                {item.itemName ? `${item.itemName}` : 'N/A'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <div className="position-relative">
                                                                                                            <span className="txt-conten-pargrap">{item.itemName}</span>
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <OverlayTrigger
                                                                                                        placement="top"
                                                                                                        overlay={
                                                                                                            <Tooltip id={item.quantity}>
                                                                                                                {item.quantity ? `${item.quantity}` : 'Enter input'}
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <div className="quanty-web-mts">
                                                                                                            <Form.Control
                                                                                                                disabled={requestType == 'Resupply' ? false : item?.isDeployed}
                                                                                                                name="quantity"
                                                                                                                type="number"
                                                                                                                min={0}
                                                                                                                className="input-tb-txt"
                                                                                                                value={item.quantity || ""}
                                                                                                                onChange={(e) => handleInputChange("lap", e, index)}

                                                                                                            // onChange={(e) =>
                                                                                                            //     setLabItems((prev) =>
                                                                                                            //         prev.map((itm, i) =>
                                                                                                            //             i === index
                                                                                                            //                 ? { ...itm, quantity: Number(e.target.value) || null }
                                                                                                            //                 : itm
                                                                                                            //         )
                                                                                                            //     )
                                                                                                            // }
                                                                                                            />
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <div className="d-flex align-items-center">
                                                                                                        <OverlayTrigger
                                                                                                            placement="top"
                                                                                                            overlay={
                                                                                                                <Tooltip id={item.suppliedBy}>
                                                                                                                    {item.suppliedBy ? `${item.suppliedBy}` : 'Select input'}
                                                                                                                </Tooltip>
                                                                                                            }
                                                                                                        >
                                                                                                            <div className="itm-select-supply-wtm">
                                                                                                                <Select
                                                                                                                    isDisabled={requestType == 'Resupply' ? false : item?.isDeployed}
                                                                                                                    onChange={(val) => handleSelectChange("lapSelect", val, index, 'suppliedBy')}
                                                                                                                    value={basinsOptions.find(o => o.value === item.suppliedBy) || null}
                                                                                                                    classNamePrefix="react-select"
                                                                                                                    className="select_itm_fld"
                                                                                                                    options={basinsOptions}
                                                                                                                    // value={item.suppliedBy}
                                                                                                                    //  onChange={(selectedOption) => handleSelectChange('lap', selectedOption, index, 'suppliedBy')}
                                                                                                                    placeholder="Select"
                                                                                                                    isSearchable={true}
                                                                                                                    isClearable
                                                                                                                    menuPortalTarget={document.body}
                                                                                                                    menuPosition="absolute"
                                                                                                                    styles={{
                                                                                                                        control: (base) => ({
                                                                                                                            ...base,
                                                                                                                            borderRadius: "8px",
                                                                                                                            borderColor: "#ccc",
                                                                                                                            minHeight: "38px",
                                                                                                                        }),
                                                                                                                        menu: (base) => ({
                                                                                                                            ...base,
                                                                                                                            zIndex: 9999,
                                                                                                                        }),
                                                                                                                    }}
                                                                                                                />
                                                                                                            </div>

                                                                                                        </OverlayTrigger>
                                                                                                        {/* <div className="d-flex align-items-center button-wt-action">
                                                                                                    <button onClick={() => handleAddData("lab", index)} type="button" className="btn icon-btn-action">
                                                                                                        <img src={plusIcon} alt="icon" />
                                                                                                    </button>
                                                                                                    <button onClick={() => handleRemoveData("lab", item)} type="button" className="btn icon-btn-action">
                                                                                                        <img src={minusIcon} alt="icon" />
                                                                                                    </button>
                                                                                                </div> */}
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </Table>
                                                                            </div>
                                                                            <div className="total-qty-footer d-flex flex-wrap align-items-center justify-content-between">
                                                                                <div className="total-ft-wth">
                                                                                    <span class="txt-label-ttl">Total QTY <span className="d-inline-block ms-3"></span>{
                                                                                        labItems.reduce((sum, e) => sum + Number(e.quantity), 0)
                                                                                    }</span>
                                                                                </div>
                                                                                <div className="d-flex justify-content-end ps-md-3 mt-3 mt-md-0">
                                                                                    <button onClick={handleSave} type="submit" className="btn save-submit-btn"><img src={arrowRightIcon} className="me-2" /> Sav</button>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        activeTab === 'hse' ?
                                                                            <>
                                                                                <div className="mb-4 mb-lg-5">
                                                                                    <Table responsive className="table-more-asts">
                                                                                        <thead className="thead-itms-wp">
                                                                                            <tr>
                                                                                                <th>Item Name</th>
                                                                                                <th className="hse-qty-thead">Quantity <span className="small-th-head">(Requested)</span></th>
                                                                                                {/* <th className="size-qty-thead">Size <span className="small-th-head">(If Applicable)</span></th> */}
                                                                                                <th className="supply-by-lab">Supplied By</th>
                                                                                                <th className="supply-by-lab">Notes</th>
                                                                                            </tr>
                                                                                        </thead>

                                                                                        <tbody className="td-align-wt">
                                                                                            {hseItems.map((val, index) => (
                                                                                                <tr key={index}>
                                                                                                    <td>
                                                                                                        <OverlayTrigger
                                                                                                            placement="top"
                                                                                                            overlay={
                                                                                                                <Tooltip id={val.itemName}>
                                                                                                                    {val.itemName ? `${val.itemName}` : 'N/A'}
                                                                                                                </Tooltip>
                                                                                                            }
                                                                                                        >
                                                                                                            <div className="position-relative">
                                                                                                                <span className="txt-conten-pargrap">{val.itemName}</span>
                                                                                                            </div>
                                                                                                        </OverlayTrigger>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <OverlayTrigger
                                                                                                            placement="top"
                                                                                                            overlay={
                                                                                                                <Tooltip id={val.quantity}>
                                                                                                                    {val.quantity ? `${val.quantity}` : 'Enter input'}
                                                                                                                </Tooltip>
                                                                                                            }
                                                                                                        >
                                                                                                            <div className="form-group-col">
                                                                                                                <Form.Control
                                                                                                                    disabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                                    type="number"
                                                                                                                    className="input-tb-txt"
                                                                                                                    name="quantity"
                                                                                                                    min={0}
                                                                                                                    value={val.quantity || ""}
                                                                                                                    onChange={(e) => handleInputChange("hse", e, index)}
                                                                                                                    placeholder=""
                                                                                                                />
                                                                                                            </div>
                                                                                                        </OverlayTrigger>
                                                                                                    </td>
                                                                                                    {/* <td>
                                                                                                <OverlayTrigger
                                                                                                    placement="top"
                                                                                                    overlay={
                                                                                                        <Tooltip id={val.size}>
                                                                                                            {val.size ? `${val.size}` : 'Enter input'}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="form-group-col">
                                                                                                        <Form.Control
                                                                                                            type="text"
                                                                                                            className="input-tb-txt"
                                                                                                            name="size"
                                                                                                            value={val.size || ""}
                                                                                                            onChange={(e) => handleInputChange("hse", e, index)}
                                                                                                            placeholder=""
                                                                                                        />
                                                                                                    </div>
                                                                                                </OverlayTrigger>
                                                                                            </td> */}
                                                                                                    <td>
                                                                                                        <div className="form-group-col">

                                                                                                            <OverlayTrigger
                                                                                                                placement="top"
                                                                                                                overlay={
                                                                                                                    <Tooltip id={val.suppliedBy}>
                                                                                                                        {val.suppliedBy ? `${val.suppliedBy}` : 'Select input'}
                                                                                                                    </Tooltip>
                                                                                                                }
                                                                                                            >
                                                                                                                <div className="d-flex align-items-center">
                                                                                                                    <div className="itm-select-supply-wtm">
                                                                                                                        <Select
                                                                                                                            isDisabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                                            isClearable={true}
                                                                                                                            classNamePrefix="react-select"
                                                                                                                            className="select_itm_fld"
                                                                                                                            options={basinsOptions}
                                                                                                                            value={basinsOptions.find(o => o.value === val.suppliedBy) || null}
                                                                                                                            onChange={(selectedOption) => handleSelectChange('hse', selectedOption, index, 'suppliedBy')}
                                                                                                                            placeholder="Select"
                                                                                                                            isSearchable={true}
                                                                                                                            menuPortalTarget={document.body}
                                                                                                                            menuPosition="absolute"
                                                                                                                            styles={{
                                                                                                                                control: (base) => ({
                                                                                                                                    ...base,
                                                                                                                                    borderRadius: "8px",
                                                                                                                                    borderColor: "#ccc",
                                                                                                                                    minHeight: "38px",
                                                                                                                                }),
                                                                                                                                menu: (base) => ({
                                                                                                                                    ...base,
                                                                                                                                    zIndex: 9999,
                                                                                                                                }),
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    {/* <div className="d-flex align-items-center button-wt-action">
                                                                                                            <button onClick={() => handleAddData("hse", index)} type="button" className="btn icon-btn-action">
                                                                                                                <img src={plusIcon} alt="icon" />
                                                                                                            </button>
                                                                                                            <button onClick={() => handleRemoveData("hse", val)} type="button" className="btn icon-btn-action">
                                                                                                                <img src={minusIcon} alt="icon" />
                                                                                                            </button>
                                                                                                        </div> */}
                                                                                                                </div>
                                                                                                            </OverlayTrigger>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <OverlayTrigger
                                                                                                            placement="top"
                                                                                                            overlay={
                                                                                                                <Tooltip id={val.Notes}>
                                                                                                                    {val.Notes ? `${val.Notes}` : 'Enter input'}
                                                                                                                </Tooltip>
                                                                                                            }
                                                                                                        >
                                                                                                            <div className="form-group-col">
                                                                                                                <Form.Control
                                                                                                                    disabled={requestType == 'Resupply' ? false : val?.isDeployed}
                                                                                                                    type="text"
                                                                                                                    className="input-tb-txt"
                                                                                                                    name="Notes"
                                                                                                                    value={val.Notes || ""}
                                                                                                                    onChange={(e) => handleInputChange("hse", e, index)}
                                                                                                                    placeholder=""
                                                                                                                />
                                                                                                            </div>
                                                                                                        </OverlayTrigger>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </Table>
                                                                                </div>

                                                                                <div className="total-qty-footer d-flex flex-wrap align-items-center justify-content-between">
                                                                                    <div className="total-ft-wth">
                                                                                        <span className="txt-label-ttl">
                                                                                            Total QTY{" "}
                                                                                            <span className="d-inline-block ms-3">
                                                                                                {hseItems.reduce((sum, e) => sum + Number(e.quantity || 0), 0)}
                                                                                            </span>
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-end ps-md-3 mt-3 mt-md-0">
                                                                                        <button onClick={handleSave} type="submit" className="btn save-submit-btn"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <div className="mb-4 mb-lg-5">
                                                                                    <Table responsive className="table-more-asts">
                                                                                        <thead className="thead-itms-wp">
                                                                                            <tr>
                                                                                                <th>Equipment Name</th>
                                                                                                <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                                                <th className="supply-by-lab">Supplied By</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody className="td-align-wt">
                                                                                            {
                                                                                                thirdParty?.map((val, i) => {
                                                                                                    return (
                                                                                                        <tr>
                                                                                                            <td>
                                                                                                                <OverlayTrigger
                                                                                                                    placement="top"
                                                                                                                    overlay={
                                                                                                                        <Tooltip id={val.AssetName}>
                                                                                                                            {val.AssetName ? `${val.AssetName}` : 'Select input'}
                                                                                                                        </Tooltip>
                                                                                                                    }
                                                                                                                >
                                                                                                                    <div>
                                                                                                                        <span className="txt-conten-pargrap">{val.AssetName}</span>

                                                                                                                    </div>
                                                                                                                </OverlayTrigger>
                                                                                                            </td>

                                                                                                            <td>
                                                                                                                <OverlayTrigger
                                                                                                                    placement="top"
                                                                                                                    overlay={
                                                                                                                        <Tooltip id={val.Quantity}>
                                                                                                                            {val.Quantity ? `${val.Quantity}` : 'Enter input'}
                                                                                                                        </Tooltip>
                                                                                                                    }
                                                                                                                >
                                                                                                                    <div className="form-group-col">
                                                                                                                        <Form.Control type="number" onChange={(e) => handleInputChange("3rdParty", e, i)}
                                                                                                                            name="Quantity" value={val.Quantity} min={0} className="input-tb-txt" placeholder="" />
                                                                                                                    </div>
                                                                                                                </OverlayTrigger>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <div className="form-group-col">
                                                                                                                    <OverlayTrigger
                                                                                                                        placement="top"
                                                                                                                        overlay={
                                                                                                                            <Tooltip id={val.SuppliedBy}>
                                                                                                                                {val.SuppliedBy ? `${val.SuppliedBy}` : 'Enter input'}
                                                                                                                            </Tooltip>
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <div className="d-flex align-items-center">
                                                                                                                            <div className="itm-select-supply-wtm">
                                                                                                                                <Form.Control onChange={(e) => handleInputChange("3rdParty", e, i)} type="text" name="SuppliedBy" value={val.SuppliedBy} className="input-tb-txt" placeholder="" />
                                                                                                                            </div>
                                                                                                                            {/* <div className="d-flex align-items-center button-wt-action">
                                                                                                                    <button onClick={() => handleAddData("3rdParty", i)} type="button" className="btn icon-btn-action">
                                                                                                                        <img src={plusIcon} alt="icon" />
                                                                                                                    </button>
                                                                                                                    <button onClick={() => handleRemoveData("3rdParty", val)} type="button" className="btn icon-btn-action">
                                                                                                                        <img src={minusIcon} alt="icon" />
                                                                                                                    </button>
                                                                                                                </div> */}
                                                                                                                        </div>
                                                                                                                    </OverlayTrigger>
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    )

                                                                                                })
                                                                                            }
                                                                                        </tbody>
                                                                                    </Table>
                                                                                </div>
                                                                                <div className="total-qty-footer d-flex flex-wrap align-items-center justify-content-between">
                                                                                    <div className="total-ft-wth">
                                                                                        <span class="txt-label-ttl">Total QTY <span className="d-inline-block ms-3"></span>{
                                                                                            thirdParty?.reduce((sum, e) => sum + Number(e.Quantity), 0)
                                                                                        }</span>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-end ps-md-3 mt-3 mt-md-0">
                                                                                        <button disabled={deals?.isDeployed} onClick={handleSave} type="submit" className="btn save-submit-btn"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                }

                                            </div>
                                        </div>

                                }

                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <>
                <Modal show={assetReset} onHide={onClose} centered>
                    <Modal.Header className="modal-header-s3s" closeButton>
                        <Modal.Title>Confirm Reset</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="card-delete-wap text-center pt-3">
                            <div className="icon-notf-web mb-3"><img src={exclamationTraingleIcon} alt="" /></div>
                            <p className="txt-wgtmult-wp">This selection will reset <strong>Supplied By</strong> and <strong> Asset Number</strong>.<br /> Are you sure?</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="pt-0 border-top-0">
                        <Button variant="secondary" className="btn-cancel-mdl" onClick={onClose}>
                            <img src={cancelIconMdl} className="me-1" alt="" />Cancel
                        </Button>
                        <Button
                            className="btn-submit-delt"
                            variant="danger"
                            onClick={() => {
                                setAssetReset(false);
                                if (pendingSelection) {
                                    onConfirm(
                                        pendingSelection.type,
                                        pendingSelection.selectedOption,
                                        pendingSelection.index,
                                        pendingSelection.supplyChain
                                    );
                                }
                            }}
                        >
                            <img src={deleteIconMdl} className="me-1" alt="" />
                            Yes, Reset
                        </Button>

                    </Modal.Footer>
                </Modal>
            </>

            <>
                <Modal show={assetDelete} onHide={onDeleteClose} centered>
                    <Modal.Header className="modal-header-s3s" closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="card-delete-wap text-center pt-3">
                            <div className="icon-notf-web mb-3"><img src={exclamationTraingleIcon} alt="" /></div>
                            <p className="txt-wgtmult-wp">This Item will be <strong>deleted.</strong> <br /> Are you sure?</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="pt-0 border-top-0">
                        <Button variant="secondary" className="btn-cancel-mdl" onClick={onDeleteClose}>
                            <img src={cancelIconMdl} className="me-1" alt="" />Cancel
                        </Button>
                        <Button
                            className="btn-submit-delt"
                            variant="danger"
                            onClick={() => {
                                setAssetDelete(false);
                                hndleEquipmentDelete()
                                // if (pendingSelection) {
                                //     onConfirm(
                                //         pendingSelection.type,
                                //         pendingSelection.selectedOption,
                                //         pendingSelection.index,
                                //         pendingSelection.supplyChain
                                //     );
                                // }
                            }}
                        >
                            <img src={deleteIconMdl} className="me-1" alt="" />
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        </>
    );
}

export default Home;